(() => {
	'use strict';
	if (window.NuBestCart) return;
	const DRAWER_SEL = '[data-nubest-cart-drawer]';
	const PAGE_SEL = '[data-nubest-cart-page]';
	const ROOT_SEL = '[data-nb-cart]';
	const OUR_HEADER = 'X-NuBest-Cart';
	const SS_INVITE = 'nbcart_invite_dismissed';
	const HIGHLIGHT_MS = 1400;
	const UNDO_MS = 6000;
	const qs = (sel, el = document) => el.querySelector(sel);
	const qsa = (sel, el = document) => Array.from(el.querySelectorAll(sel));
	const toInt = (v, d = 0) => {
		const n = parseInt(v, 10);
		return Number.isFinite(n) ? n : d;
	};
	const parseJSON = (s, d = null) => {
		try {
			return JSON.parse(s);
		} catch (e) {
			return d;
		}
	};
	const normalizeProperties = (props) => {
		if (props == null) return undefined;
		if (!Array.isArray(props)) {
			if (typeof props !== 'object') return undefined;
			const out = Object.assign({}, props);
			return Object.keys(out).length ? out : undefined;
		}
		const out = {};
		props.forEach((entry) => {
			if (Array.isArray(entry) && entry.length >= 2) {
				out[String(entry[0])] = entry[1];
				return;
			}
			if (!entry || typeof entry !== 'object') return;
			if ('name' in entry && 'value' in entry) {
				out[String(entry.name)] = entry.value;
			} else if ('key' in entry && 'value' in entry) {
				out[String(entry.key)] = entry.value;
			} else {
				Object.assign(out, entry);
			}
		});
		return Object.keys(out).length ? out : undefined;
	};
	const raf = (fn) => (window.requestAnimationFrame ? requestAnimationFrame(fn) : setTimeout(fn, 16));
	const reducedMotion = () => window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	const isNarrow = () => window.matchMedia && window.matchMedia('(max-width: 640px)').matches;
	let debug = !1;
	const log = (...a) => {
		if (debug) console.log('[NuBestCart]', ...a);
	};
	const track = (event, payload = {}) => {
		try {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push(
				Object.assign(
					{
						event,
					},
					payload,
				),
			);
		} catch (e) {}
	};

	function formatMoney(value, digit = 2) {
		if (window.T4SThemeSP && T4SThemeSP.Currency && typeof T4SThemeSP.Currency.formatMoney === 'function') {
			const format = window.T4Sconfigs && T4Sconfigs.moneyFormat ? T4Sconfigs.moneyFormat : '${{amount}}';
			return T4SThemeSP.Currency.formatMoney(value, digit ? format : format.replace(/\{\{.*?\}\}/, '{{amount_no_decimals}}'));
		}
		const amount = (Number(value) || 0) / 100;
		const locale = window.Shopify && Shopify.locale && Shopify.country ? `${Shopify.locale}-${Shopify.country}` : undefined;
		const currency = window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : 'USD';
		const localized = amount
			.toLocaleString(locale, {
				style: 'currency',
				currency,
				maximumFractionDigits: digit,
				minimumFractionDigits: digit,
			})
			.replace(/[^\d.,-]/g, '');
		const format = window.T4Sconfigs && T4Sconfigs.moneyFormat ? T4Sconfigs.moneyFormat : '${{amount}}';
		return format.replace(/\{\{.*?\}\}/, localized);
	}
	const everyText = (days) => (days === 1 ? 'every day' : days > 1 ? `every ${days} days` : 'on your schedule');
	const focusables = (scope) => qsa('button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])', scope).filter((el) => !el.disabled && !el.hidden && !el.closest('[hidden]') && el.getClientRects().length > 0);
	const api = {
		seq: 0,
		route(path) {
			const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
			return root.replace(/\/$/, '') + '/' + path.replace(/^\//, '');
		},
		sectionsUrl() {
			return window.location.pathname + window.location.search;
		},
		async post(path, body, sectionIds) {
			const payload = Object.assign({}, body);
			if (/\/cart\/add\.js(?:\?|$)/.test(path) && Array.isArray(payload.items)) {
				payload.items = payload.items.map((item) => {
					const next = Object.assign({}, item);
					if (next.properties !== undefined) {
						const properties = normalizeProperties(next.properties);
						if (properties) next.properties = properties;
						else delete next.properties;
					}
					return next;
				});
			} else if (/\/cart\/change\.js(?:\?|$)/.test(path) && payload.properties !== undefined) {
				const properties = normalizeProperties(payload.properties);
				if (properties) payload.properties = properties;
				else delete payload.properties;
			}
			if (sectionIds && sectionIds.length) {
				payload.sections = sectionIds.join(',');
				payload.sections_url = this.sectionsUrl();
			}
			const res = await fetch(this.route(path), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					Accept: 'application/json',
					[OUR_HEADER]: '1',
				},
				body: JSON.stringify(payload),
				credentials: 'same-origin',
			});
			const json = await res.json().catch(() => ({}));
			if (!res.ok) {
				const err = new Error(json.description || json.message || `Cart request failed (${res.status})`);
				err.status = res.status;
				err.payload = json;
				throw err;
			}
			return json;
		},
		async addForm(formData, sectionIds) {
			if (sectionIds && sectionIds.length) {
				formData.set('sections', sectionIds.join(','));
				formData.set('sections_url', this.sectionsUrl());
			}
			const res = await fetch(this.route('/cart/add.js'), {
				method: 'POST',
				headers: {
					Accept: 'application/json',
					[OUR_HEADER]: '1',
				},
				body: formData,
				credentials: 'same-origin',
			});
			const json = await res.json().catch(() => ({}));
			if (!res.ok) {
				const err = new Error(json.description || json.message || `Could not add to cart (${res.status})`);
				err.status = res.status;
				err.payload = json;
				throw err;
			}
			return json;
		},
		async getSections(sectionIds, urlOverride = null) {
			const url = urlOverride || this.sectionsUrl();
			const path = `${url.includes('?') ? '&' : '?'}sections=${encodeURIComponent(sectionIds.join(','))}`;
			const res = await fetch(url + path, {
				headers: {
					[OUR_HEADER]: '1',
				},
				credentials: 'same-origin',
				cache: 'no-store',
			});
			if (!res.ok) throw new Error(`Section render failed (${res.status})`);
			return res.json();
		},
		async getCart() {
			const res = await fetch(this.route('/cart.js'), {
				headers: {
					Accept: 'application/json',
					[OUR_HEADER]: '1',
				},
				credentials: 'same-origin',
				cache: 'no-store',
			});
			if (!res.ok) throw new Error('cart.js failed');
			return res.json();
		},
	};
	class CartController {
		constructor() {
			this.views = [];
			this.busy = !1;
			this.checkoutPending = !1;
			this.actionButton = null;
			this.backgroundSync = !1;
			this.pending = null;
			this.undo = null;
			this.undoTimer = 0;
			this.drafts = new Map();
			this.expanded = new Set();
			this.addedKey = null;
			this.packOpen = !1;
			this.giftDraft = null;
			this.giftContext = null;
			this.giftOpen = !1;
			this.reqSeq = 0;
			this.queuedRefresh = null;
			this.activeRefresh = null;
			this.autoFixDone = new Set();
			this.bundleRestoreStarted = !1;
			this.appliedCodes = null;
			this.dismissedInvite = (() => {
				try {
					const value = sessionStorage.getItem(SS_INVITE) || '';
					if (value === '1') {
						sessionStorage.removeItem(SS_INVITE);
						return '';
					}
					return value;
				} catch (e) {
					return '';
				}
			})();
		}
		register(view) {
			this.views.push(view);
			view.controller = this;
		}
		unregister(view) {
			this.views = this.views.filter((v) => v !== view);
		}
		sectionIds() {
			return Array.from(new Set(this.views.map((v) => v.sectionId).filter(Boolean)));
		}
		drawer() {
			return this.views.find((v) => v.context === 'drawer');
		}
		page() {
			return this.views.find((v) => v.context === 'page');
		}
		anyView() {
			return this.views[0];
		}
		snapshot() {
			const v = this.anyView();
			return v
				? v.snapshot()
				: {
						items: [],
						note: '',
					};
		}
		money(c) {
			return formatMoney(c);
		}
		setActionButton(button) {
			this.actionButton = button && button.nodeType === 1 ? button : null;
		}
		setBusy(on, background = !1) {
			this.busy = on;
			this.backgroundSync = on && background;
			if (this.backgroundSync) this.actionButton = null;
			this.views.forEach((v) => v.setBusy(on, this.backgroundSync, this.actionButton));
			if (!on) this.actionButton = null;
			if (!on && this.queuedRefresh) {
				Promise.resolve().then(() => {
					if (this.busy || !this.queuedRefresh) return;
					const queued = this.queuedRefresh;
					this.queuedRefresh = null;
					this.refresh(queued.opts).then(queued.resolve, queued.reject);
				});
			}
		}
		showError(text, canRetry, canReload = !1) {
			this.views.forEach((v) => v.showError(text, canRetry, canReload));
		}
		hideError() {
			this.views.forEach((v) => v.hideError());
		}
		setUndo(undo) {
			clearTimeout(this.undoTimer);
			this.undoTimer = 0;
			this.undo = undo;
			this.views.forEach((v) => v.renderUndo(undo));
			if (undo) {
				const currentUndo = undo;
				this.undoTimer = setTimeout(() => {
					if (this.undo === currentUndo) this.setUndo(null);
				}, UNDO_MS);
			}
		}
		compactSteps(steps) {
			const out = [];
			let qtyUpdates = null;
			let addItems = null;
			const flushQty = () => {
				if (!qtyUpdates || !Object.keys(qtyUpdates).length) return;
				out.push({
					type: 'update',
					body: {
						updates: qtyUpdates,
					},
				});
				qtyUpdates = null;
			};
			const flushAdds = () => {
				if (!addItems || !addItems.length) return;
				out.push({
					type: 'add',
					items: addItems,
				});
				addItems = null;
			};
			const flush = () => {
				flushQty();
				flushAdds();
			};
			(steps || []).forEach((step) => {
				if (!step || !step.type) return;
				if (step.type === 'change' && step.id && step.quantity !== undefined && step.selling_plan === undefined && step.properties === undefined) {
					flushAdds();
					if (!qtyUpdates) qtyUpdates = {};
					qtyUpdates[String(step.id)] = step.quantity;
					return;
				}
				if (step.type === 'add' && Array.isArray(step.items) && step.items.length) {
					flushQty();
					if (!addItems) addItems = [];
					addItems.push(...step.items);
					return;
				}
				flush();
				out.push(step);
			});
			flush();
			return out;
		}
		async run(label, steps, opts = {}) {
			if (this.busy || !steps.length) return !1;
			if (!opts.internal) this.autoFixDone.clear();
			const compacted = this.compactSteps(steps);
			if (!compacted.length) return !1;
			const prevSnapshot = this.snapshot();
			if (!opts.internal) {
				this.cartStart({
					source: opts.source || 'mutation',
					label,
					snapshot: prevSnapshot,
				});
			}
			this.pending = {
				label,
				steps: compacted,
				index: 0,
				opts,
				prevSnapshot,
			};
			return this.execute();
		}
		async retry() {
			if (this.pending && !this.busy) {
				this.hideError();
				return this.execute();
			}
		}
		isStaleLineError(err) {
			return !!err && err.status === 422;
		}
		lineSignature(item) {
			if (!item) return '';
			const allocation = item.selling_plan_allocation;
			const plan = item.selling_plan != null ? item.selling_plan : allocation && allocation.selling_plan && allocation.selling_plan.id;
			const properties = normalizeProperties(item.properties) || {};
			const normalized = Object.keys(properties)
				.sort()
				.map((key) => [key, String(properties[key])]);
			return JSON.stringify([Number(item.id || item.variant_id), String(plan || ''), normalized]);
		}
		rebaseStaleSteps(job, cart) {
			const oldItems = (job.prevSnapshot && job.prevSnapshot.items) || [];
			const freshItems = (cart && cart.items) || [];
			const freshBySignature = new Map();
			freshItems.forEach((item) => {
				const signature = this.lineSignature(item);
				if (!freshBySignature.has(signature)) freshBySignature.set(signature, []);
				freshBySignature.get(signature).push(item);
			});
			const keyMap = new Map();
			oldItems.forEach((item) => {
				const matches = freshBySignature.get(this.lineSignature(item));
				const match = matches && matches.shift();
				if (match) keyMap.set(String(item.key), String(match.key));
			});
			let remaining = 0;
			job.steps.slice(job.index).forEach((step) => {
				if (step.type === 'change') {
					const next = keyMap.get(String(step.id));
					step.skip = !next;
					if (next) {
						step.id = next;
						remaining++;
					}
					return;
				}
				if (step.type === 'update' && step.body && step.body.updates) {
					const updates = {};
					Object.entries(step.body.updates).forEach(([id, quantity]) => {
						if (/^\d+$/.test(id)) updates[id] = quantity;
						else if (keyMap.has(id)) updates[keyMap.get(id)] = quantity;
					});
					step.body.updates = updates;
					step.skip = !Object.keys(updates).length && !step.body.attributes && step.body.note === undefined && step.body.discount === undefined;
					if (!step.skip) remaining++;
					return;
				}
				remaining++;
			});
			return remaining;
		}
		async execute() {
			const job = this.pending;
			if (!job) return !1;
			const seq = ++this.reqSeq;
			this.setBusy(!0, !!job.opts.internal);
			this.hideError();
			let result = null;
			try {
				for (; job.index < job.steps.length; job.index++) {
					const step = job.steps[job.index];
					if (step.skip) continue;
					const last = job.index === job.steps.length - 1;
					const ids = last ? this.sectionIds() : null;
					if (step.type === 'add') {
						result = await api.post(
							'/cart/add.js',
							{
								items: step.items,
							},
							ids,
						);
						if (step.remember && result) {
							const items = result.items || [result];
							step.addedKeys = items.map((it) => it.key);
						}
					} else if (step.type === 'change') {
						const body = {};
						if (step.selling_plan !== undefined) {
							const items = job.liveItems || (job.prevSnapshot && job.prevSnapshot.items) || [];
							const lineIndex = items.findIndex((item) => String(item.key) === String(step.id));
							if (lineIndex < 0) {
								const stale = new Error('No valid id or line parameter');
								stale.status = 422;
								throw stale;
							}
							body.line = lineIndex + 1;
						} else {
							body.id = step.id;
						}
						if (step.quantity !== undefined) body.quantity = step.quantity;
						if (step.selling_plan !== undefined) body.selling_plan = step.selling_plan;
						if (step.properties !== undefined) body.properties = step.properties;
						result = await api.post('/cart/change.js', body, ids);
					} else if (step.type === 'update') {
						result = await api.post('/cart/update.js', step.body, ids);
					}
					if (result && result.item_count !== undefined && Array.isArray(result.items)) job.liveItems = result.items;
				}
			} catch (err) {
				log('mutation failed', err);
				if (seq !== this.reqSeq) return !1;
				if (this.isStaleLineError(err)) {
					if (job.staleRetry) {
						try {
							const html = await api.getSections(this.sectionIds());
							this.applySections(html, {});
						} catch (e) {}
						this.pending = null;
						this.setBusy(!1);
						this.showError('Your cart changed while it was updating. Reload to continue with the latest cart.', !1, !0);
						track('cart_update_failed', {
							label: job.label,
							step: job.index,
							reason: 'stale_key_retry',
						});
						return !1;
					}
					job.staleRetry = !0;
					try {
						const cart = await api.getCart();
						const html = await api.getSections(this.sectionIds());
						this.applySections(html, {
							cart,
						});
						job.liveItems = cart.items || [];
						if (this.rebaseStaleSteps(job, cart)) return this.execute();
						this.pending = null;
						this.setBusy(!1);
						this.showError('Your cart was changed in another tab. Reload to continue with the latest cart.', !1, !0);
						return !1;
					} catch (syncErr) {
						log('stale cart recovery failed', syncErr);
						this.pending = null;
						this.setBusy(!1);
						this.showError("We couldn't refresh your cart. Reload the page and try again.", !1, !0);
						track('cart_update_failed', {
							label: job.label,
							step: job.index,
							reason: 'stale_key_sync',
						});
						return !1;
					}
				}
				try {
					const html = await api.getSections(this.sectionIds());
					this.applySections(html, {});
				} catch (e) {}
				this.setBusy(!1);
				const partial = job.index > 0;
				this.showError(job.opts.errorText || (partial ? "We couldn't finish updating your cart. Retry to complete the change." : "We couldn't update your cart. Your previous cart is unchanged."), !0);
				track('cart_update_failed', {
					label: job.label,
					step: job.index,
				});
				return !1;
			}
			if (seq !== this.reqSeq) return !1;
			this.pending = null;
			const opts = job.opts;
			let renderedSections = result && result.sections ? result.sections : {};
			const expectedSections = this.sectionIds();
			if (expectedSections.some((id) => typeof renderedSections[id] !== 'string')) {
				try {
					renderedSections = await api.getSections(expectedSections);
				} catch (e) {}
			}
			let flashKey = opts.flashKey || null;
			if (opts.flashTarget && result && result.sections) {
				const snap = this.parseSnapshot(result.sections);
				const hit = snap && snap.items.find((it) => it.id === opts.flashTarget.id && String(it.selling_plan || '') === String(opts.flashTarget.selling_plan || ''));
				if (hit) flashKey = hit.key;
			}
			if (opts.addedTarget && result && result.sections) {
				const snap = this.parseSnapshot(result.sections);
				const hit = snap && snap.items.find((it) => it.id === opts.addedTarget.id && String(it.selling_plan || '') === String(opts.addedTarget.selling_plan || ''));
				if (hit) this.addedKey = hit.key;
			}
			if (opts.clearDraftKey) this.drafts.delete(opts.clearDraftKey);
			if (opts.clearDrafts) this.drafts.clear();
			this.applySections(renderedSections, {
				flashKey,
				cart: result,
			});
			this.setBusy(!1);
			if (opts.undoable || opts.undoText) {
				const snapAfter = this.snapshot();
				const snapshot = opts.undoable ? (opts.chainUndo && this.undo ? this.undo.snapshot : job.prevSnapshot) : null;
				this.setUndo({
					text: opts.undoText || job.label,
					snapshot,
					sticky: snapAfter.items.filter((i) => i.kind === 'r').length === 0,
				});
			} else if (this.undo && !this.undo.sticky && !opts.internal) {
				this.setUndo(null);
			}
			if (opts.after) opts.after(result);
			await this.autoFix();
			if (!opts.internal) {
				this.cartDone({
					source: 'mutation',
					label: job.label,
					cart: result,
				});
			}
			return result;
		}
		parseSnapshot(sections) {
			for (const id of Object.keys(sections || {})) {
				const html = sections[id];
				if (!html) continue;
				const tpl = document.createElement('template');
				tpl.innerHTML = html;
				const s = qs('[data-cart-snapshot]', tpl.content);
				if (s) return parseJSON(s.textContent, null);
			}
			return null;
		}
		cartStart(detail = {}) {
			document.dispatchEvent(
				new CustomEvent('nubest:cart:start', {
					detail: Object.assign(
						{
							snapshot: this.snapshot(),
							source: 'unknown',
							label: '',
						},
						detail,
					),
				}),
			);
		}
		cartDone(detail = {}) {
			document.dispatchEvent(
				new CustomEvent('nubest:cart:done', {
					detail: Object.assign(
						{
							snapshot: this.snapshot(),
							source: 'unknown',
							label: '',
						},
						detail,
					),
				}),
			);
		}
		applySections(sections, ctx) {
			this.views.forEach((v) => {
				const html = sections && sections[v.sectionId];
				if (html) v.applyHtml(html, ctx);
			});
			this.updateHeaderCount();
			document.dispatchEvent(
				new CustomEvent('nubest:cart:updated', {
					detail: {
						snapshot: this.snapshot(),
						cart: ctx && ctx.cart,
					},
				}),
			);
		}
		async refresh(opts = {}) {
			if (this.busy) {
				if (!this.queuedRefresh) {
					const queued = {
						opts,
					};
					queued.promise = new Promise((resolve, reject) => {
						queued.resolve = resolve;
						queued.reject = reject;
					});
					this.queuedRefresh = queued;
				}
				return this.queuedRefresh.promise;
			}
			const ids = this.sectionIds();
			if (!ids.length) return;
			const signature = ids.join(',');
			if (!opts.force && this.activeRefresh && this.activeRefresh.seq === this.reqSeq && this.activeRefresh.signature === signature) {
				return this.activeRefresh.promise;
			}
			const seq = ++this.reqSeq;
			const active = {
				seq,
				signature,
			};
			this.activeRefresh = active;
			this.cartStart({
				source: opts.source || 'refresh',
				label: opts.label || 'Cart refreshed',
			});
			active.promise = (async () => {
				try {
					const html = await api.getSections(ids);
					if (seq !== this.reqSeq) return;
					this.applySections(html, opts);
					await this.autoFix();
					this.cartDone({
						source: opts.source || 'refresh',
						label: opts.label || 'Cart refreshed',
						cart: opts.cart,
					});
				} catch (e) {
					log('refresh failed', e);
				} finally {
					if (this.activeRefresh === active) this.activeRefresh = null;
				}
			})();
			return active.promise;
		}
		updateHeaderCount() {
			const v = this.anyView();
			if (!v) return;
			const count = toInt(v.root.dataset.itemCount, 0);
			this.views.forEach((view) => {
				if (view.context !== 'drawer' && !view.host.hasAttribute('data-nubest-cart-drawer')) return;
				const shell = view.host.closest('#t4s-mini_cart');
				[view.host, shell].filter(Boolean).forEach((el) => {
					el.setAttribute('data-ccount', String(count));
					if (window.jQuery) window.jQuery(el).data('ccount', count);
				});
			});
			const sels = this.views
				.map((x) => x.config.countSelectors)
				.filter(Boolean)
				.join(',');
			if (!sels) return;
			qsa(sels).forEach((el) => {
				if (el.closest(ROOT_SEL)) return;
				el.textContent = String(count);
				if (el.hasAttribute('data-cart-count')) el.setAttribute('data-cart-count', String(count));
			});
		}
		async autoFix() {
			const v = this.anyView();
			if (!v || this.busy) return;
			const items = this.snapshot().items || [];
			const productIds = new Set(items.map((item) => String(item.product_id)));
			const invalidUpdates = {};
			items.forEach((item) => {
				const properties = normalizeProperties(item.properties) || {};
				const pairingProductId = properties._perfect_pairings_by;
				const bundleItem = Object.prototype.hasOwnProperty.call(properties, '_nubest_bundle');
				const paidGift = properties._my_extra_discount === 'Free Gift' && Number(item.final_price) > 0;
				const orphanPairing = pairingProductId != null && String(pairingProductId).trim() !== '' && !productIds.has(String(pairingProductId).trim());
				if (!item.key || (!paidGift && !orphanPairing && !bundleItem)) return;
				const sig = `invalid-extra:${item.key}`;
				if (this.autoFixDone.has(sig)) return;
				this.autoFixDone.add(sig);
				invalidUpdates[String(item.key)] = 0;
			});
			if (Object.keys(invalidUpdates).length) {
				return this.run(
					'Invalid cart extras removed',
					[
						{
							type: 'update',
							body: {
								updates: invalidUpdates,
							},
						},
					],
					{
						internal: !0,
						errorText: "We couldn't remove invalid cart extras. Retry to complete the change.",
					},
				);
			}
			const fixEl = qs('[data-reward-fixes]', v.root);
			const fixes = fixEl ? parseJSON(fixEl.textContent, []) : [];
			const addItems = [];
			const updates = {};
			let touched = !1;
			let protectionTouched = !1;
			if (Array.isArray(fixes)) {
				fixes.forEach((fix) => {
					if (!fix || !fix.action) return;
					const sig = `reward:${fix.action}:${fix.key || ''}:${fix.variantId || ''}:${fix.discountName || ''}:${fix.reason || ''}`;
					if (this.autoFixDone.has(sig)) return;
					this.autoFixDone.add(sig);
					const properties = {
						_nubest_reward_tier: 'true',
						_my_boost_type: 'NuBest Gift',
						_my_extra_discount: fix.discountName || '',
					};
					if (fix.action === 'add' && toInt(fix.variantId)) {
						addItems.push({
							id: toInt(fix.variantId),
							quantity: 1,
							properties,
						});
						touched = !0;
					} else if (fix.action === 'replace' && fix.key && toInt(fix.variantId)) {
						addItems.push({
							id: toInt(fix.variantId),
							quantity: 1,
							properties,
						});
						updates[String(fix.key)] = 0;
						touched = !0;
					} else if (fix.action === 'remove' && fix.key) {
						updates[String(fix.key)] = 0;
						touched = !0;
					}
					track('reward_auto_fixed', {
						action: fix.action,
						tier: fix.discountName || '',
						reason: fix.reason || '',
					});
				});
			}
			const d = v.root.dataset;
			const savedByNeedsInit = d.savedbyInitialized !== 'true';
			if (savedByNeedsInit) touched = !0;
			if (d.protectionRemoveKey) {
				const sig = `prot-rm:${d.protectionRemoveKey}`;
				if (!this.autoFixDone.has(sig)) {
					this.autoFixDone.add(sig);
					updates[String(d.protectionRemoveKey)] = 0;
					touched = !0;
					protectionTouched = !0;
				}
			}
			if (d.protectionAddVariant) {
				const variantId = toInt(d.protectionAddVariant);
				const sig = `prot-add:${variantId}:${d.eligibleSubtotal || ''}`;
				if (variantId && !this.autoFixDone.has(sig)) {
					this.autoFixDone.add(sig);
					updates[String(variantId)] = 1;
					touched = !0;
					protectionTouched = !0;
				}
			}
			if (d.protectionFixKey && d.protectionFixVariant) {
				const variantId = toInt(d.protectionFixVariant);
				const sig = `prot-fix:${d.protectionFixKey}:${variantId}`;
				if (variantId && !this.autoFixDone.has(sig)) {
					this.autoFixDone.add(sig);
					updates[String(d.protectionFixKey)] = 0;
					updates[String(variantId)] = 1;
					touched = !0;
					protectionTouched = !0;
				}
			}
			if (!touched) return;
			const steps = [];
			if (addItems.length)
				steps.push({
					type: 'add',
					items: addItems,
				});
			if (Object.keys(updates).length || savedByNeedsInit) {
				const body = {};
				if (Object.keys(updates).length) body.updates = updates;
				if (savedByNeedsInit) {
					body.attributes = {
						'_SavedBy-internal': '1',
					};
				} else if (protectionTouched && (d.savedbyValue === '0' || d.savedbyValue === '1')) {
					body.attributes = {
						'_SavedBy-internal': d.savedbyValue,
					};
				}
				steps.push({
					type: 'update',
					body,
				});
			}
			await this.run('Cart extras updated', steps, {
				internal: !0,
				errorText: "We couldn't finish updating cart rewards or protection. Retry to complete the change.",
			});
		}
		async waitUntilIdle() {
			while (this.busy) await new Promise((resolve) => setTimeout(resolve, 50));
		}
		async autoAddBundles() {
			if (this.bundleRestoreStarted || document.querySelector('.Bundle2025-product-item')) return;
			const configEl = document.getElementById('BundleStoreConfig');
			const configs = configEl ? parseJSON(configEl.textContent, []) : [];
			if (!Array.isArray(configs) || !configs.length) return;
			const storageKey = 'Bundle2025';
			let state;
			try {
				state = parseJSON(localStorage.getItem(storageKey) || '{}', {});
			} catch (e) {
				return;
			}
			if (!state || typeof state !== 'object' || Array.isArray(state) || !Object.keys(state).length) return;
			this.bundleRestoreStarted = !0;
			for (const config of configs) {
				const bundleState = config && state[config.handle];
				if (!bundleState || typeof bundleState !== 'object' || Array.isArray(bundleState) || !config.steps || typeof config.steps !== 'object' || Array.isArray(config.steps)) continue;
				let valid = !0;
				Object.keys(config.steps).forEach((stepKey) => {
					const stepConfig = config.steps[stepKey] || {};
					const allowed = new Set((Array.isArray(stepConfig.items) ? stepConfig.items : []).map(Number));
					const merged = new Map();
					(Array.isArray(bundleState[stepKey]) ? bundleState[stepKey] : []).forEach((item) => {
						const id = item && Number(item.id);
						if (!Number.isSafeInteger(id) || id <= 0 || !allowed.has(id)) return;
						const rawQuantity = Number(item.quantity);
						const quantity = Number.isSafeInteger(rawQuantity) && rawQuantity > 0 ? rawQuantity : 1;
						const current = merged.get(id);
						if (current) {
							if (Number.isSafeInteger(current.quantity + quantity)) current.quantity += quantity;
							else valid = !1;
						} else
							merged.set(
								id,
								Object.assign({}, item, {
									id,
									quantity,
								}),
							);
					});
					let stepItems = Array.from(merged.values());
					const max = Number(stepConfig.max) || 0;
					if (max && stepItems.length > max) stepItems = stepItems.slice(0, max);
					bundleState[stepKey] = stepItems;
					if (stepItems.length < (Number(stepConfig.min) || 0)) valid = !1;
				});
				Object.keys(bundleState).forEach((key) => {
					if (!config.steps[key]) delete bundleState[key];
				});
				Object.keys(config.steps).forEach((key) => {
					if (!bundleState[key]) bundleState[key] = [];
				});
				state[config.handle] = bundleState;
				if (!valid) continue;
				const selectedItems = Object.values(bundleState)
					.flat()
					.filter((item) => item.quantity > 0);
				if (!selectedItems.length) continue;
				await this.waitUntilIdle();
				if (this.pending || this.checkoutPending) break;
				let cart;
				try {
					cart = await api.getCart();
				} catch (e) {
					break;
				}
				await this.waitUntilIdle();
				if (this.pending || this.checkoutPending) break;
				const bundleProperty = {
					key: Date.now(),
					id: config.id,
					bundle: config.name,
				};
				const items = selectedItems.map(({ id, quantity, name, sku, handle, price }) => ({
					id,
					quantity,
					properties: {
						_nubest_bundle: JSON.stringify(
							Object.assign({}, bundleProperty, {
								name,
								sku,
								handle,
								quantity,
								price,
							}),
						),
						_my_boost_type: 'Bundle Builder',
					},
				}));
				const result = await this.run(
					'Bundle added',
					[
						{
							type: 'add',
							items,
						},
					],
					{
						internal: !0,
						errorText: "We couldn't add your saved bundle. Reload the page to try again.",
						after: () => {
							delete state[config.handle];
							try {
								localStorage.setItem(storageKey, JSON.stringify(state));
							} catch (e) {}
						},
					},
				);
				if (!result) break;
			}
			try {
				localStorage.setItem(storageKey, JSON.stringify(state));
			} catch (e) {}
		}
		lineName(lineEl) {
			return lineEl.dataset.name || 'this item';
		}
		changeQty(lineEl, delta) {
			const qty = toInt(lineEl.dataset.qty, 1) + delta;
			if (qty < 1) return;
			track('line_qty_changed', {
				key: lineEl.dataset.key,
				qty,
			});
			return this.run(
				'Quantity updated',
				[
					{
						type: 'change',
						id: lineEl.dataset.key,
						quantity: qty,
					},
				],
				{},
			);
		}
		removeLine(lineEl) {
			const key = lineEl.dataset.key;
			const snap = this.snapshot();
			const items = Array.isArray(snap.items) ? snap.items : [];
			const regularItems = items.filter((it) => it && it.kind === 'r');
			const giftItems = items.filter((it) => it && it.kind === 'g' && it.key);
			const protectionItems = items.filter((it) => it && it.kind === 'p' && it.key);
			const removingLastRegular = regularItems.length === 1 && regularItems[0].key === key;
			let steps;
			if (removingLastRegular) {
				const updates = {
					[key]: 0,
				};
				giftItems.forEach((it) => {
					updates[it.key] = 0;
				});
				protectionItems.forEach((it) => {
					updates[it.key] = 0;
				});
				steps = [
					{
						type: 'update',
						body: {
							updates,
							attributes: {
								'_SavedBy-internal': '1',
							},
						},
					},
				];
			} else {
				steps = [
					{
						type: 'change',
						id: key,
						quantity: 0,
					},
				];
			}
			track('line_removed', {
				key,
				giftCount: removingLastRegular ? giftItems.length : 0,
				protectionCount: removingLastRegular ? protectionItems.length : 0,
				lastRegular: removingLastRegular,
			});
			this.drafts.delete(key);
			return this.run(`Removed ${this.lineName(lineEl)}`, steps, {
				undoable: !0,
			});
		}
		acceptInvite(btn) {
			const key = btn.dataset.key;
			const type = btn.dataset.inviteType;
			const lineEl = this.findLine(key);
			const variantId = toInt(btn.dataset.variantId);
			const planId = toInt(btn.dataset.planId);
			const qty = toInt(btn.dataset.qty, 1);
			if (!lineEl || lineEl.dataset.editable !== 'true' || !variantId || !planId) return;
			track('invite_accepted', {
				type,
				key,
			});
			this.packOpen = !1;
			const sameVariant = toInt(lineEl.dataset.variantId) === variantId;
			const steps = sameVariant
				? [
						{
							type: 'change',
							id: key,
							selling_plan: planId,
							quantity: qty,
						},
					]
				: [
						{
							type: 'add',
							items: [
								{
									id: variantId,
									quantity: qty,
									selling_plan: planId,
									properties: this.lineProps(key),
								},
							],
						},
						{
							type: 'change',
							id: key,
							quantity: 0,
						},
					];
			const pack = toInt(btn.dataset.pack);
			const label = type === 'pack' ? `Switched ${this.lineName(lineEl)} to ${pack} ${lineEl.dataset.unitWord || 'bottle'}${pack === 1 ? '' : 's'}` : `Switched ${this.lineName(lineEl)} to subscription`;
			return this.run(label, steps, {
				undoable: !0,
				flashTarget: {
					id: variantId,
					selling_plan: planId,
				},
			});
		}
		inviteToken(view) {
			const v = view || this.anyView();
			if (!v || !v.root) return '';
			const key = v.root.dataset.inviteKey || '';
			const type = v.root.dataset.inviteType || '';
			return key && type ? `${type}:${key}` : '';
		}
		isInviteDismissed(view) {
			const token = this.inviteToken(view);
			return !!token && token === this.dismissedInvite;
		}
		dismissInvite(trackIt = !0, view = null) {
			const token = this.inviteToken(view);
			this.dismissedInvite = token;
			try {
				if (token) sessionStorage.setItem(SS_INVITE, token);
				else sessionStorage.removeItem(SS_INVITE);
			} catch (e) {}
			this.packOpen = !1;
			this.views.forEach((v) => v.applyInviteState());
			if (trackIt)
				track('invite_dismissed', {
					token,
				});
		}
		findLine(key) {
			for (const v of this.views) {
				const el = v.line(key);
				if (el) return el;
			}
			return null;
		}
		lineProps(key) {
			const it = this.snapshot().items.find((i) => i.key === key);
			return normalizeProperties(it && it.properties);
		}
		openEditor(lineEl, preset) {
			if (!lineEl || lineEl.dataset.editable !== 'true') return;
			const key = lineEl.dataset.key;
			const d = this.drafts.get(key) || {
				purchase: lineEl.dataset.purchase === 'sub' ? 'sub' : 'onetime',
				variantId: toInt(lineEl.dataset.variantId),
				planId: toInt(lineEl.dataset.planId) || null,
				qty: toInt(lineEl.dataset.qty, 1),
				cadenceOpen: !1,
				spin: 0,
			};
			if (preset) {
				if (preset.variantId && preset.variantId !== d.variantId) this.convertQtyForPack(lineEl, d, preset.variantId);
				Object.assign(d, preset);
			}
			this.drafts.set(key, d);
			this.expanded.add(key);
			this.views.forEach((v) => v.renderLineState(key));
			const v = this.views.find((x) => x.line(key));
			if (v) v.focusFirstIn(v.line(key), '[data-line-editor]');
		}
		closeEditor(key) {
			this.drafts.delete(key);
			this.views.forEach((v) => v.renderLineState(key));
		}
		convertQtyForPack(lineEl, d, newVariantId) {
			const rows = LineModel.packRows(lineEl);
			const from = rows.find((r) => r.variantId === d.variantId);
			const to = rows.find((r) => r.variantId === newVariantId);
			if (!from || !to) return;
			const bottles = from.pack * (d.qty || 1);
			if (to.pack > 1 && from.pack < to.pack) d.qty = Math.max(1, Math.floor(bottles / to.pack));
		}
		setDraft(key, patch) {
			const d = this.drafts.get(key);
			if (!d) return;
			if (patch.purchase && patch.purchase !== d.purchase) d.spin = (d.spin || 0) + 1;
			if (patch.variantId && patch.variantId !== d.variantId) {
				const el = this.findLine(key);
				if (el) this.convertQtyForPack(el, d, patch.variantId);
			}
			Object.assign(d, patch);
			if (d.purchase === 'sub' && !d.planId) {
				const el = this.findLine(key);
				const r = el ? this.resolve(el, d) : null;
				if (r && r.purchase === 'sub') d.planId = r.planId;
			}
			this.views.forEach((v) => v.renderLineState(key));
		}
		resolve(lineEl, d) {
			const rows = LineModel.packRows(lineEl);
			const qty = Math.max(1, toInt(d.qty, toInt(lineEl.dataset.qty, 1)));
			const row = rows.find((r) => r.variantId === d.variantId) || rows[0];
			if (!row) return null;
			const out = {
				row,
				rows,
				qty,
			};
			if (d.purchase === 'sub') {
				const planIds = Object.keys(row.plans);
				if (!planIds.length) {
					out.purchase = 'onetime';
				} else {
					let planId = String(d.planId || '');
					if (!row.plans[planId]) planId = String(LineModel.defaultPlanId(lineEl, row.variantId) || '');
					if (!row.plans[planId]) planId = planIds[0];
					const p = row.plans[planId];
					out.purchase = 'sub';
					out.planId = toInt(planId);
					out.days = p.d;
					out.planName = String(p.n || '').trim();
					out.total = p.p * qty;
					out.compare = p.c * qty;
					out.renewA = p.ra * qty;
					out.renewB = p.rb * qty;
					out.renewCount = p.rc;
					out.target = {
						id: row.variantId,
						quantity: qty,
						selling_plan: toInt(planId),
					};
				}
			}
			if (out.purchase !== 'sub') {
				out.purchase = 'onetime';
				out.total = row.otPrice * qty;
				out.compare = row.otCompare * qty;
				out.target =
					row.otMode === 'single'
						? {
								id: row.otVariantId,
								quantity: row.pack * qty,
								selling_plan: null,
							}
						: {
								id: row.variantId,
								quantity: qty,
								selling_plan: null,
							};
			}
			const cur = {
				id: toInt(lineEl.dataset.variantId),
				quantity: toInt(lineEl.dataset.qty, 1),
				selling_plan: toInt(lineEl.dataset.planId) || null,
			};
			out.dirty = cur.id !== out.target.id || cur.quantity !== out.target.quantity || String(cur.selling_plan || '') !== String(out.target.selling_plan || '');
			return out;
		}
		dirtyLines() {
			const out = [];
			for (const [key] of this.drafts) {
				const el = this.findLine(key);
				if (!el) continue;
				const r = this.resolve(el, this.drafts.get(key));
				if (r && r.dirty)
					out.push({
						key,
						el,
						r,
					});
			}
			return out;
		}
		saveDraft(key) {
			const lineEl = this.findLine(key);
			const d = this.drafts.get(key);
			if (!lineEl || !d) return;
			const r = this.resolve(lineEl, d);
			if (!r || !r.dirty) {
				this.closeEditor(key);
				return;
			}
			const cur = {
				id: toInt(lineEl.dataset.variantId),
				planId: toInt(lineEl.dataset.planId) || null,
			};
			const t = r.target;
			const steps =
				t.id === cur.id
					? [
							{
								type: 'change',
								id: key,
								quantity: t.quantity,
								selling_plan: t.selling_plan,
							},
						]
					: [
							{
								type: 'add',
								items: [
									{
										id: t.id,
										quantity: t.quantity,
										selling_plan: t.selling_plan || undefined,
										properties: this.lineProps(key),
									},
								],
							},
							{
								type: 'change',
								id: key,
								quantity: 0,
							},
						];
			track('line_option_saved', {
				key,
				from: {
					purchase: lineEl.dataset.purchase,
					variantId: cur.id,
					planId: cur.planId,
				},
				to: {
					purchase: r.purchase,
					variantId: t.id,
					planId: t.selling_plan,
				},
			});
			return this.run(`Updated ${this.lineName(lineEl)}`, steps, {
				undoable: !0,
				clearDraftKey: key,
				flashTarget: {
					id: t.id,
					selling_plan: t.selling_plan,
				},
			});
		}
		saveAll() {
			const dirty = this.dirtyLines();
			if (!dirty.length) return !1;
			const steps = [];
			const names = [];
			for (const { key, el: lineEl, r } of dirty) {
				const cur = {
					id: toInt(lineEl.dataset.variantId),
					planId: toInt(lineEl.dataset.planId) || null,
				};
				const t = r.target;
				if (t.id === cur.id) {
					steps.push({
						type: 'change',
						id: key,
						quantity: t.quantity,
						selling_plan: t.selling_plan,
					});
				} else {
					steps.push({
						type: 'add',
						items: [
							{
								id: t.id,
								quantity: t.quantity,
								selling_plan: t.selling_plan || undefined,
								properties: this.lineProps(key),
							},
						],
					});
					steps.push({
						type: 'change',
						id: key,
						quantity: 0,
					});
				}
				names.push(this.lineName(lineEl));
				track('line_option_saved', {
					key,
					from: {
						purchase: lineEl.dataset.purchase,
						variantId: cur.id,
						planId: cur.planId,
					},
					to: {
						purchase: r.purchase,
						variantId: t.id,
						planId: t.selling_plan,
					},
				});
			}
			return this.run(dirty.length === 1 ? `Updated ${names[0]}` : `Updated ${dirty.length} items`, steps, {
				undoable: !0,
				clearDrafts: !0,
				errorText: "We couldn't save all your changes. Retry to complete the update.",
			});
		}
		cancelAll() {
			const keys = Array.from(this.drafts.keys());
			this.drafts.clear();
			keys.forEach((k) => this.views.forEach((v) => v.renderLineState(k)));
		}
		confirmGift(view) {
			if (this.busy) return;
			const v = view;
			const pick = this.giftDraft;
			const ctx = this.giftContext;
			if (!pick || !ctx || !ctx.discountName || pick.discountName !== ctx.discountName) return;
			const currentKey = ctx.currentKey || '';
			const current = this.snapshot().items.find((item) => item.key === currentKey);
			if (current && toInt(current.id) === toInt(pick.variantId) && current.quantity === 1) {
				v.closeGiftSheet();
				return;
			}
			const steps = [];
			steps.push({
				type: 'add',
				items: [
					{
						id: pick.variantId,
						quantity: 1,
						properties: {
							_nubest_reward_tier: 'true',
							_my_boost_type: 'NuBest Gift',
							_my_extra_discount: ctx.discountName,
						},
					},
				],
			});
			if (currentKey)
				steps.push({
					type: 'change',
					id: currentKey,
					quantity: 0,
				});
			track('gift_selected', {
				id: pick.variantId,
				tier: ctx.discountName,
			});
			v.closeGiftSheet();
			return this.run(currentKey ? 'Free gift changed' : 'Free gift added', steps, {
				undoable: !1,
			});
		}
		toggleProtection(card, on) {
			track('protection_toggled', {
				on,
			});
			const variantId = toInt(card.dataset.variantId);
			const key = card.dataset.key;
			const body = {
				attributes: {
					'_SavedBy-internal': on ? '1' : '0',
				},
			};
			if (on) {
				if (!key && variantId)
					body.updates = {
						[variantId]: 1,
					};
				return this.run(
					'Package Protection added',
					[
						{
							type: 'update',
							body,
						},
					],
					{},
				);
			}
			if (key)
				body.updates = {
					[key]: 0,
				};
			return this.run(
				'Package Protection removed',
				[
					{
						type: 'update',
						body,
					},
				],
				{},
			);
		}
		async doUndo() {
			const u = this.undo;
			if (!u || !u.snapshot || this.busy) return;
			this.setUndo(null);
			track('undo_used', {});
			const cur = this.snapshot();
			const sig = (it) => `${it.id}|${it.selling_plan || ''}|${JSON.stringify(normalizeProperties(it.properties) || {})}`;
			const steps = [];
			const adds = [];
			u.snapshot.items.forEach((p) => {
				const c = cur.items.find((x) => sig(x) === sig(p));
				if (!c)
					adds.push({
						id: p.id,
						quantity: p.quantity,
						selling_plan: p.selling_plan || undefined,
						properties: normalizeProperties(p.properties),
					});
			});
			if (adds.length)
				steps.push({
					type: 'add',
					items: adds,
				});
			u.snapshot.items.forEach((p) => {
				const c = cur.items.find((x) => sig(x) === sig(p));
				if (c && c.quantity !== p.quantity)
					steps.push({
						type: 'change',
						id: c.key,
						quantity: p.quantity,
					});
			});
			cur.items.forEach((c) => {
				if (!u.snapshot.items.find((p) => sig(p) === sig(c)))
					steps.push({
						type: 'change',
						id: c.key,
						quantity: 0,
					});
			});
			if (u.snapshot.protectionValue !== undefined && u.snapshot.protectionValue !== cur.protectionValue) {
				steps.push({
					type: 'update',
					body: {
						attributes: {
							'_SavedBy-internal': toInt(u.snapshot.protectionValue) === 1 ? '1' : '0',
						},
					},
				});
			}
			if (!steps.length) return;
			return this.run('Restored', steps, {
				clearDrafts: !0,
			});
		}
		checkout(view, button) {
			if (this.busy || this.checkoutPending || (this.pending && this.pending.opts.internal)) return;
			if (this.dirtyLines().length) {
				view.flashDirty();
				return;
			}
			const root = view.root;
			track('checkout_clicked', {
				due: toInt(root.dataset.due),
				hasSub: root.dataset.hasSub === 'true',
			});
			this.setActionButton(button);
			this.checkoutPending = !0;
			this.views.forEach((cartView) => cartView.renderDirty());
			window.location.href = view.config.checkoutUrl || '/checkout';
		}
	}
	const LineModel = {
		packRows(lineEl) {
			return qsa('[data-pack-row]', lineEl).map((el) => ({
				el,
				variantId: toInt(el.dataset.variantId),
				pack: toInt(el.dataset.pack, 1),
				available: el.dataset.available !== 'false',
				otMode: el.dataset.otMode || 'variant',
				otVariantId: toInt(el.dataset.otVariantId),
				otPrice: toInt(el.dataset.otPrice),
				otCompare: toInt(el.dataset.otCompare),
				plans: parseJSON(el.dataset.subPlans, {}) || {},
			}));
		},
		cadenceRows(lineEl) {
			return qsa('[data-cadence-row]', lineEl).map((el) => ({
				el,
				planId: el.dataset.planId,
				name: (el.dataset.planName || '').trim(),
			}));
		},
		cadenceList(lineEl, variantId) {
			return qsa('[data-cadence-list]', lineEl).find((el) => toInt(el.dataset.variantId) === toInt(variantId)) || null;
		},
		defaultPlanId(lineEl, variantId) {
			const list = this.cadenceList(lineEl, variantId);
			if (!list) return null;
			const recSub = qs('.nb-cadence__sub.is-rec', list);
			const recRow = recSub && recSub.closest('[data-cadence-row]');
			if (recRow) return toInt(recRow.dataset.planId) || null;
			const selected = qs('[data-cadence-row][aria-checked="true"]', list);
			if (selected) return toInt(selected.dataset.planId) || null;
			const packRow = this.packRows(lineEl).find((row) => row.variantId === toInt(variantId));
			const ids = packRow ? Object.keys(packRow.plans) : [];
			return ids.length ? toInt(ids[0]) : null;
		},
	};
	class CartView {
		constructor(hostEl, context) {
			this.host = hostEl;
			this.context = context;
			this.config = parseJSON(hostEl.dataset.config, {}) || {};
			this.root = qs(ROOT_SEL, hostEl);
			if (!this.root) {
				const sibling = hostEl.nextElementSibling;
				if (sibling && sibling.matches && sibling.matches(ROOT_SEL)) this.root = sibling;
			}
			this.eventScope = this.root && !hostEl.contains(this.root) ? hostEl.parentElement || hostEl : hostEl;
			this.sectionId = this.root ? this.root.dataset.sectionId : this.config.sectionId;
			this.highlightTimer = 0;
			this.stashServerHtml(this.root);
			if (this.root) this.bind();
		}
		snapshot() {
			const s = this.root && qs('[data-cart-snapshot]', this.root);
			return (
				(s && parseJSON(s.textContent, null)) || {
					items: [],
					note: '',
				}
			);
		}
		line(key) {
			return this.root ? qs(`[data-line][data-key="${CSS.escape(key)}"]`, this.root) : null;
		}
		lines() {
			return this.root ? qsa('[data-line]', this.root) : [];
		}
		money(c) {
			return formatMoney(c);
		}
		stashServerHtml(root) {
			if (!root) return;
			qsa('[data-region], [data-line-wrap]', root).forEach((el) => {
				if (el.__nbHtml === undefined) el.__nbHtml = el.outerHTML;
			});
		}
		applyHtml(html, ctx = {}) {
			const tpl = document.createElement('template');
			tpl.innerHTML = html;
			const newRoot = qs(ROOT_SEL, tpl.content);
			if (!newRoot || !this.root) return;
			const focusKey = document.activeElement && this.root.contains(document.activeElement) ? document.activeElement.dataset.fk : null;
			const oldProgress = qs('[data-progress-fill]', this.root);
			const oldWidth = oldProgress ? oldProgress.style.width : null;
			Array.from(newRoot.attributes).forEach((a) => {
				if ((a.name.startsWith('data-') || a.name === 'class') && this.root.getAttribute(a.name) !== a.value) this.root.setAttribute(a.name, a.value);
			});
			Array.from(this.root.attributes).forEach((a) => {
				if (a.name.startsWith('data-') && !newRoot.hasAttribute(a.name)) this.root.removeAttribute(a.name);
			});
			const oldSnap = qs('[data-cart-snapshot]', this.root);
			const newSnap = qs('[data-cart-snapshot]', newRoot);
			if (oldSnap && newSnap && oldSnap.textContent !== newSnap.textContent) oldSnap.textContent = newSnap.textContent;
			const oldRewardFixes = qs('[data-reward-fixes]', this.root);
			const newRewardFixes = qs('[data-reward-fixes]', newRoot);
			if (oldRewardFixes && newRewardFixes && oldRewardFixes.textContent !== newRewardFixes.textContent) oldRewardFixes.textContent = newRewardFixes.textContent;
			this.morphContainer(this.root, newRoot);
			if (oldWidth !== null) {
				const fill = qs('[data-progress-fill]', this.root);
				if (fill && fill.style.width !== oldWidth && !reducedMotion()) {
					const target = fill.style.width;
					fill.style.transition = 'none';
					fill.style.width = oldWidth;
					raf(() => {
						fill.style.transition = '';
						fill.style.width = target;
					});
				}
			}
			this.afterRender();
			if (ctx.flashKey) this.highlight(ctx.flashKey, !1);
			if (focusKey) {
				const el = qs(`[data-fk="${CSS.escape(focusKey)}"]`, this.root);
				if (el && document.activeElement !== el && el.getClientRects().length) {
					try {
						el.focus({
							preventScroll: !0,
						});
					} catch (e) {
						el.focus();
					}
				}
			}
		}
		morphContainer(oldParent, newParent) {
			const keyOf = (el) => (el.nodeType === 1 ? (el.dataset.region ? `r:${el.dataset.region}` : el.dataset.key && el.hasAttribute('data-line-wrap') ? `k:${el.dataset.key}` : null) : null);
			const newChildren = Array.from(newParent.children);
			const oldChildren = Array.from(oldParent.children);
			const oldByKey = new Map();
			oldChildren.forEach((el) => {
				const k = keyOf(el);
				if (k) oldByKey.set(k, el);
			});
			let cursor = null;
			newChildren.forEach((nEl) => {
				const k = keyOf(nEl);
				const newHtml = k ? nEl.outerHTML : null;
				let node;
				if (k && oldByKey.has(k)) {
					const oEl = oldByKey.get(k);
					oldByKey.delete(k);
					if (oEl.__nbHtml === newHtml) {
						node = oEl;
					} else if (k.startsWith('r:') && nEl.dataset.region === 'lines') {
						this.morphContainer(oEl, nEl);
						oEl.__nbHtml = newHtml;
						node = oEl;
					} else {
						node = nEl.cloneNode(!0);
						node.__nbHtml = newHtml;
						oEl.replaceWith(node);
					}
				} else if (k) {
					node = nEl.cloneNode(!0);
					node.__nbHtml = newHtml;
				} else if (nEl.hasAttribute('data-scroll') || nEl.classList.contains('nb-cart__bodywrap') || nEl.classList.contains('nb-page__cols') || nEl.classList.contains('nb-page__main') || nEl.classList.contains('nb-aside') || nEl.classList.contains('nb-aside__body')) {
					const cls = nEl.className.split(' ')[0];
					const oEl = oldChildren.find((c) => c.parentElement === oldParent && c.classList && c.classList.contains(cls) && !c.__nbMatched);
					if (oEl) {
						oEl.__nbMatched = !0;
						this.morphContainer(oEl, nEl);
						node = oEl;
					} else {
						node = nEl.cloneNode(!0);
					}
				} else {
					const oEl = oldChildren.find((c) => c.parentElement === oldParent && !c.__nbMatched && c.tagName === nEl.tagName && c.className === nEl.className && !keyOf(c));
					if (oEl) {
						oEl.__nbMatched = !0;
						node = oEl;
						if (oEl.hasAttribute('data-cart-snapshot')) oEl.textContent = nEl.textContent;
					} else node = nEl.cloneNode(!0);
				}
				const ref = cursor ? cursor.nextSibling : oldParent.firstChild;
				if (node !== ref) oldParent.insertBefore(node, ref);
				cursor = node;
			});
			oldChildren.forEach((c) => {
				if (c.__nbMatched) {
					c.__nbMatched = !1;
				}
			});
			let n = cursor ? cursor.nextSibling : oldParent.firstChild;
			while (n) {
				const next = n.nextSibling;
				n.remove();
				n = next;
			}
		}
		afterRender() {
			const c = this.controller;
			if (!c) return;
			this.stashServerHtml(this.root);
			this.applyInviteState();
			this.applyCompactState();
			this.lines().forEach((l) => this.renderLineState(l.dataset.key, !0));
			this.renderGiftSheetState();
			this.renderProtectionDetails();
			this.afterRenderExtra();
			this.renderUndo(c.undo);
			this.setBusy(this.controller.busy, this.controller.backgroundSync);
		}
		afterRenderExtra() {}
		applyInviteState() {
			const c = this.controller;
			const invite = qs('[data-invite]', this.root);
			const note = qs('[data-subnote]', this.root);
			const dismissed = c.isInviteDismissed(this);
			if (invite) invite.hidden = dismissed;
			if (note) note.hidden = !(dismissed || !invite || invite.dataset.invite !== 'sub');
			const pack = qs('[data-invite="pack"]', this.root);
			if (pack) {
				const body = qs('[data-pack-body]', pack);
				const btn = qs('[data-action="pack-toggle"]', pack);
				const lbl = qs('[data-pack-label]', pack);
				if (body) body.hidden = !c.packOpen;
				if (btn) btn.setAttribute('aria-expanded', c.packOpen ? 'true' : 'false');
				if (lbl) lbl.textContent = c.packOpen ? 'Hide' : 'See details';
			}
			if (invite && !dismissed && !invite.__nbTracked) {
				invite.__nbTracked = !0;
				track('invite_shown', {
					type: invite.dataset.invite,
				});
			}
		}
		applyCompactState() {
			const c = this.controller;
			const inviteKey = this.root.dataset.inviteKey;
			const firstKey = this.root.dataset.firstKey;
			const compactable = this.lines().filter((l) => l.classList.contains('nb-line--compactable'));
			const openKey = c.addedKey && this.line(c.addedKey) ? c.addedKey : firstKey;
			compactable.forEach((l) => {
				const key = l.dataset.key;
				const open = key === openKey || c.expanded.has(key) || c.drafts.has(key) || (key === inviteKey && !c.isInviteDismissed(this));
				l.classList.toggle('is-compact', !open);
				const btn = qs('[data-action="expand"]', l);
				if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
			});
		}
		renderLineState(key, skipDirty = !1) {
			const lineEl = this.line(key);
			if (!lineEl) return;
			const c = this.controller;
			const d = c.drafts.get(key);
			const summary = qs('[data-line-summary]', lineEl);
			const editor = qs('[data-line-editor]', lineEl);
			if (!editor) return;
			if (!d) {
				editor.hidden = !0;
				if (summary) summary.hidden = !1;
				if (!skipDirty) this.renderDirty();
				return;
			}
			if (summary) summary.hidden = !0;
			editor.hidden = !1;
			const r = c.resolve(lineEl, d);
			if (!r) return;
			const qty = r.qty;
			qsa('[data-editor-purchase] [data-action="draft-purchase"]', lineEl).forEach((b) => b.setAttribute('aria-checked', b.dataset.value === r.purchase ? 'true' : 'false'));
			const ico = qs('.nb-switch__ico', lineEl);
			if (ico) ico.style.transform = `rotate(${(d.spin || 0) * 180}deg)`;
			const subnote = qs('[data-editor-subnote]', lineEl);
			if (subnote) subnote.hidden = r.purchase !== 'sub';
			const unitWord = lineEl.dataset.unitWord || 'bottle';
			r.rows.forEach((row) => {
				const sel = row.variantId === r.row.variantId;
				row.el.setAttribute('aria-checked', sel ? 'true' : 'false');
				row.el.classList.toggle('is-selected', sel);
				let total,
					compare,
					chip = '';
				if (r.purchase === 'sub' && Object.keys(row.plans).length) {
					let pid = String(r.planId || '');
					if (!row.plans[pid]) pid = String(LineModel.defaultPlanId(lineEl, row.variantId) || '');
					if (!row.plans[pid]) pid = Object.keys(row.plans)[0];
					const p = row.plans[pid];
					total = p.p;
					compare = p.c;
					if (compare > total) chip = `Save ${Math.round(((compare - total) * 100) / compare)}%`;
				} else {
					total = row.otPrice;
					compare = row.otCompare;
				}
				const perUnit = row.pack > 0 ? Math.round(total / row.pack) : total;
				const t = qs('[data-pack-total]', row.el);
				if (t) t.textContent = this.money(total);
				const cp = qs('[data-pack-compare]', row.el);
				if (cp) {
					cp.hidden = !(compare > total);
					cp.textContent = compare > total ? this.money(compare) : '';
				}
				const u = qs('[data-pack-unit]', row.el);
				if (u) u.textContent = row.pack > 1 ? `${this.money(perUnit)}/${unitWord}` : r.purchase === 'sub' ? 'try it first' : `${this.money(total)} each`;
				const ch = qs('[data-pack-chip]', row.el);
				if (ch) {
					ch.hidden = !chip;
					ch.textContent = chip;
				}
			});
			const cadPanel = qs('[data-editor-cadence]', lineEl);
			if (cadPanel) {
				cadPanel.hidden = r.purchase !== 'sub';
				if (r.purchase === 'sub') {
					const lists = qsa('[data-cadence-list]', cadPanel);
					const list = lists.find((el) => toInt(el.dataset.variantId) === r.row.variantId);
					lists.forEach((el) => {
						const active = el === list;
						el.hidden = !active || !d.cadenceOpen;
					});
					const tog = qs('[data-action="toggle-cadence"]', cadPanel);
					const togLbl = qs('[data-cadence-toggle-label]', cadPanel);
					if (list) list.hidden = !d.cadenceOpen;
					if (tog) tog.setAttribute('aria-expanded', d.cadenceOpen ? 'true' : 'false');
					if (togLbl) togLbl.textContent = d.cadenceOpen ? 'Done' : 'Adjust';
					const txt = qs('[data-cadence-text]', cadPanel);
					if (txt) txt.textContent = r.planName || everyText(r.days);
					const cadenceRows = list ? LineModel.cadenceRows(list) : [];
					const selectedPlan = r.row.plans[String(r.planId)] || null;
					const selectedNameKey = String((selectedPlan && selectedPlan.n) || r.planName || '')
						.trim()
						.toLowerCase();
					const renderedNames = new Set();
					cadenceRows.forEach((cr) => {
						const planData = r.row.plans[cr.planId];
						const avail = !!planData;
						const sel = String(cr.planId) === String(r.planId);
						const planName = String((planData && planData.n) || cr.name || '').trim();
						const nameKey = planName.toLowerCase();
						let duplicate = !1;
						if (avail && nameKey) {
							if (selectedNameKey && nameKey === selectedNameKey && !sel) duplicate = !0;
							else if (renderedNames.has(nameKey)) duplicate = !0;
							else renderedNames.add(nameKey);
						}
						cr.el.hidden = !avail || duplicate;
						cr.el.setAttribute('aria-checked', sel ? 'true' : 'false');
						cr.el.classList.toggle('is-selected', sel);
					});
					const warn = qs('[data-cadence-mismatch]', cadPanel);
					if (warn) {
						const rec = LineModel.defaultPlanId(lineEl, r.row.variantId);
						const recData = rec ? r.row.plans[String(rec)] : null;
						const recDays = recData ? toInt(recData.d) : 0;
						const mismatch = !!recData && String(rec) !== String(r.planId) && r.days > 0 && recDays > 0 && r.days < recDays;
						warn.hidden = !mismatch;
						if (mismatch) {
							const wt = qs('[data-mismatch-text]', warn);
							if (wt) wt.textContent = `This is a ${r.row.pack}-${unitWord} supply — you may get more than you need.`;
							const recName = String(recData.n || '').trim();
							const wc = qs('[data-mismatch-cta]', warn);
							if (wc) wc.textContent = `Use ${recName || everyText(recDays)}`;
							warn.dataset.recPlan = rec || '';
						} else {
							warn.dataset.recPlan = '';
						}
					}
				}
			}
			const nudge = qs('[data-editor-nudge]', lineEl);
			if (nudge) {
				const planIds = Object.keys(r.row.plans);
				const show = r.purchase === 'onetime' && planIds.length > 0;
				nudge.hidden = !show;
				if (show) {
					const pid = LineModel.defaultPlanId(lineEl, r.row.variantId) || toInt(planIds[0]);
					const p = r.row.plans[String(pid)];
					if (!p) {
						nudge.hidden = !0;
						return;
					}
					const subTotal = p.p * qty;
					const nt = qs('[data-nudge-title]', nudge);
					if (nt) nt.textContent = `Subscribers pay ${this.money(subTotal)} for this order`;
					const ns = qs('[data-nudge-ship]', nudge);
					if (ns) ns.hidden = !(toInt(this.root.dataset.merch) < toInt(this.root.dataset.freeShip));
					const nc = qs('[data-nudge-cta]', nudge);
					if (nc) nc.textContent = r.total > subTotal ? `Switch & save ${this.money(r.total - subTotal)} →` : 'Switch to Subscribe & Save →';
					nudge.dataset.planId = pid;
				}
			}
			const cur = toInt(lineEl.dataset.linePrice);
			const diff = r.total - cur;
			const today = qs('[data-editor-today]', lineEl);
			if (today) {
				if (!r.dirty) {
					today.textContent = `Price today ${this.money(cur)}`;
				} else {
					const disc = toInt(lineEl.dataset.lineDiscount) > 0 ? ' before discounts' : '';
					const qtyNote = qty > 1 ? ` for ${qty} × ${r.row.pack > 1 ? `${r.row.pack}-${unitWord}pack` : `1 ${unitWord}`}` : '';
					today.textContent = `Price today ${this.money(r.total)}${qtyNote}${disc}` + (diff !== 0 ? ` (${diff < 0 ? '−' : '+'}${this.money(Math.abs(diff))} vs. current)` : '');
				}
			}
			const ren = qs('[data-editor-renewal]', lineEl);
			if (ren) {
				if (r.purchase === 'sub') {
					const planLabel = r.planName || everyText(r.days);
					ren.textContent = r.renewB > 0 ? `Renews at ${this.money(r.renewA)} for ${r.renewCount === 1 ? 'your first refill' : `refills 1–${r.renewCount}`}, then ${this.money(r.renewB)} · ${planLabel}` : `Renews at ${this.money(r.renewA)} ${planLabel}`;
				} else ren.textContent = 'One-time purchase · no renewal';
			}
			const saveLbl = qs('[data-save-label]', lineEl);
			if (saveLbl) saveLbl.textContent = r.dirty ? 'Save changes' : 'Done';
			const saveBtn = qs('[data-action="save"]', lineEl);
			if (saveBtn) saveBtn.disabled = !r.row.available;
			if (!skipDirty) this.renderDirty();
		}
		renderDirty() {
			const c = this.controller;
			const dirty = c.dirtyLines();
			const hasDirty = dirty.length > 0;
			const dirtyText = hasDirty ? `Save your changes to ${dirty.map((x) => x.el.dataset.name).join(' and ')} before checking out.` : '';
			qsa('[data-dirty]', this.root).forEach((b) => {
				if (b.hidden !== !hasDirty) b.hidden = !hasDirty;
				const t = qs('[data-dirty-text]', b);
				if (t && t.textContent !== dirtyText) t.textContent = dirtyText;
			});
			const loading = c.busy || c.checkoutPending;
			const disabled = hasDirty || loading || !!(c.pending && c.pending.opts.internal) || this.root.classList.contains('is-empty');
			qsa('[data-action="checkout"]', this.root).forEach((b) => {
				if (b.disabled !== disabled) b.disabled = disabled;
				const ariaDisabled = disabled ? 'true' : 'false';
				if (b.getAttribute('aria-disabled') !== ariaDisabled) b.setAttribute('aria-disabled', ariaDisabled);
				const checkoutLoading = c.checkoutPending && c.actionButton === b;
				if (checkoutLoading && b.getAttribute('aria-busy') !== 'true') b.setAttribute('aria-busy', 'true');
				else if (!checkoutLoading && b.hasAttribute('aria-busy')) b.removeAttribute('aria-busy');
			});
		}
		flashDirty() {
			const b = qs('[data-dirty]', this.root);
			if (b) {
				b.classList.remove('nb-dirty');
				raf(() => b.classList.add('nb-dirty'));
				b.scrollIntoView({
					block: 'nearest',
					behavior: reducedMotion() ? 'auto' : 'smooth',
				});
			}
		}
		setBusy(on, background = !1, actionButton = null) {
			const loading = on && !background;
			this.root.classList.toggle('is-busy', on);
			this.root.classList.toggle('is-syncing', on && background);
			qsa('[data-nb-action-loading="true"]', this.root).forEach((button) => {
				button.removeAttribute('data-nb-action-loading');
				button.removeAttribute('aria-busy');
			});
			if (loading && actionButton && this.root.contains(actionButton)) {
				actionButton.setAttribute('data-nb-action-loading', 'true');
				actionButton.setAttribute('aria-busy', 'true');
			}
			qsa('[data-busy-pill]', this.root).forEach((p) => {
				if (p.hidden !== !loading) p.hidden = !loading;
			});
			this.renderDirty();
		}
		showError(text, canRetry, canReload = !1) {
			qsa('[data-error]', this.root).forEach((e) => {
				e.hidden = !1;
				const t = qs('[data-error-text]', e);
				if (t) t.textContent = text;
				const retry = qs('[data-action="retry"]', e);
				if (retry) retry.hidden = !canRetry;
				const secondary = qs('[data-action="error-dismiss"], [data-action="reload"]', e);
				if (secondary) {
					secondary.setAttribute('data-action', canReload ? 'reload' : 'error-dismiss');
					secondary.textContent = canReload ? 'Reload' : 'Dismiss';
				}
			});
		}
		hideError() {
			qsa('[data-error]', this.root).forEach((e) => {
				e.hidden = !0;
			});
		}
		renderUndo(undo) {
			qsa('[data-undo]', this.root).forEach((u) => {
				u.hidden = !undo;
				const t = qs('[data-undo-text]', u);
				if (t) t.textContent = undo ? undo.text : '';
				const b = qs('[data-action="undo"]', u);
				if (b) b.hidden = !(undo && undo.snapshot);
			});
		}
		highlight(key, scroll) {
			const el = this.line(key);
			if (!el) return;
			clearTimeout(this.highlightTimer);
			this.lines().forEach((l) => l.classList.remove('is-highlight'));
			el.classList.add('is-highlight');
			this.highlightTimer = setTimeout(() => el.classList.remove('is-highlight'), HIGHLIGHT_MS);
			if (scroll) this.scrollToLine(el);
		}
		scrollToLine(el) {
			const sc = qs('[data-scroll]', this.root);
			if (sc) {
				sc.scrollTop = Math.max(0, el.offsetTop - sc.offsetTop - 14);
			} else {
				const y = el.getBoundingClientRect().top + window.pageYOffset - 90;
				window.scrollTo({
					top: Math.max(0, y),
					behavior: reducedMotion() ? 'auto' : 'smooth',
				});
			}
		}
		focusFirstIn(lineEl, sel) {
			const scope = sel ? qs(sel, lineEl) : lineEl;
			if (!scope) return;
			const f = focusables(scope)[0];
			if (f) {
				try {
					f.focus({
						preventScroll: !0,
					});
				} catch (e) {
					f.focus();
				}
			}
		}
		openGiftSheet(opener) {
			const ov = qs('[data-gift-overlay]', this.root);
			if (!ov) return;
			const c = this.controller;
			const discountName = opener && opener.dataset ? opener.dataset.giftKey || '' : '';
			if (!discountName) return;
			c.giftOpen = !0;
			c.giftDraft = null;
			c.giftContext = {
				discountName,
				currentKey: opener.dataset.currentKey || '',
			};
			this.giftOpener = opener || document.activeElement;
			ov.hidden = !1;
			this.host.classList.add('has-sheet');
			this.renderGiftSheetState();
			track('gift_sheet_opened', {
				tier: discountName,
			});
			const sheet = qs('[data-gift-sheet]', ov);
			setTimeout(() => {
				const f = focusables(sheet)[0];
				if (f) f.focus();
			}, 60);
		}
		closeGiftSheet() {
			const ov = qs('[data-gift-overlay]', this.root);
			if (!ov) return;
			const c = this.controller;
			c.giftOpen = !1;
			c.giftDraft = null;
			c.giftContext = null;
			ov.hidden = !0;
			this.host.classList.remove('has-sheet');
			const op = this.giftOpener;
			this.giftOpener = null;
			if (op && op.isConnected)
				setTimeout(
					() =>
						op.focus({
							preventScroll: !0,
						}),
					30,
				);
		}
		renderGiftSheetState() {
			const ov = qs('[data-gift-overlay]', this.root);
			if (!ov) return;
			const c = this.controller;
			const ctx = c.giftContext;
			ov.hidden = !(c.giftOpen && ctx && ctx.discountName);
			const rows = qsa('[data-gift-row]', ov);
			const activeRows = [];
			rows.forEach((r) => {
				const active = !!ctx && String(r.dataset.giftTierKey || '') === String(ctx.discountName || '');
				r.hidden = !active;
				if (active) activeRows.push(r);
			});
			const draft = c.giftDraft && ctx && c.giftDraft.discountName === ctx.discountName ? c.giftDraft : null;
			const currentSelected = activeRows.find((r) => r.dataset.current === 'true');
			activeRows.forEach((r) => {
				const sel = draft ? String(r.dataset.variantId) === String(draft.variantId) : r === currentSelected;
				r.setAttribute('aria-checked', sel ? 'true' : 'false');
				r.classList.toggle('is-selected', sel);
			});
			const confirm = qs('[data-action="gift-confirm"]', ov);
			const lbl = qs('[data-gift-confirm-label]', ov);
			const isNew = draft && (!currentSelected || String(currentSelected.dataset.variantId) !== String(draft.variantId));
			if (confirm) confirm.disabled = !isNew;
			if (lbl) lbl.textContent = isNew ? `Use ${draft.name} as my gift` : draft ? 'Already your gift' : 'Select a gift';
		}
		openProtectionInfo(trigger) {
			const template = qs('[data-savedby-popup-template]', this.root);
			if (!template || qs('.nb-savedby-popup[open]')) return;
			const dialog = template.content.firstElementChild.cloneNode(!0);
			document.body.appendChild(dialog);
			dialog.addEventListener('keydown', (event) => event.stopPropagation());
			dialog.addEventListener('click', (event) => {
				if (event.target.closest('[data-savedby-close]')) dialog.close();
				else if (event.target === dialog) {
					const rect = dialog.getBoundingClientRect();
					if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
				}
			});
			dialog.addEventListener(
				'close',
				() => {
					dialog.remove();
					const target = trigger.isConnected ? trigger : qs('[data-action="protection-info"]', this.root);
					if (target) target.focus();
				},
				{
					once: !0,
				},
			);
			dialog.showModal();
		}
		renderProtectionDetails() {
			const btn = qs('[data-action="protection-details"]', this.root);
			const det = qs('[data-protection-details]', this.root);
			const lbl = qs('[data-protection-details-label]', this.root);
			if (!btn || !det) return;
			const open = !!this.controller.protDetails;
			det.hidden = !open;
			btn.setAttribute('aria-expanded', open ? 'true' : 'false');
			if (lbl) lbl.textContent = open ? 'Hide details' : 'Details';
		}
		bind() {
			const scope = this.eventScope || this.host;
			scope.addEventListener('click', (e) => this.onClick(e));
			scope.addEventListener('change', (e) => this.onChange(e));
			scope.addEventListener('keydown', (e) => this.onKeydown(e));
		}
		ownsNode(el) {
			return !!el && (this.host.contains(el) || (this.root && this.root.contains(el)));
		}
		onChange(e) {
			const t = e.target;
			if (!this.ownsNode(t)) return;
			if (t.matches('[data-action="protection-toggle"]')) {
				const card = t.closest('[data-protection]');
				const on = t.checked;
				if (this.controller.busy) {
					t.checked = !on;
					return;
				}
				card.classList.toggle('is-on', on);
				this.controller.toggleProtection(card, on);
			}
		}
		onClick(e) {
			const btn = e.target.closest('[data-action]');
			if (!btn || !this.ownsNode(btn)) return;
			const c = this.controller;
			const action = btn.dataset.action;
			const lineEl = btn.closest('[data-line]');
			const key = lineEl ? lineEl.dataset.key : btn.dataset.key || null;
			const busyBlocked = ['qty-inc', 'qty-dec', 'remove', 'save', 'save-all', 'invite-accept', 'gift-confirm', 'undo', 'promo-remove'];
			if (c.busy && busyBlocked.includes(action)) {
				e.preventDefault();
				return;
			}
			const asyncActions = ['qty-inc', 'qty-dec', 'remove', 'save', 'save-all', 'invite-accept', 'gift-confirm', 'retry', 'undo', 'promo-remove'];
			if (!c.busy && asyncActions.includes(action)) c.setActionButton(btn);
			switch (action) {
				case 'close':
					e.preventDefault();
					if (this.close) this.close();
					break;
				case 'qty-inc':
					e.preventDefault();
					c.changeQty(lineEl, +1);
					break;
				case 'qty-dec':
					e.preventDefault();
					c.changeQty(lineEl, -1);
					break;
				case 'remove':
					e.preventDefault();
					c.removeLine(lineEl);
					break;
				case 'expand':
					e.preventDefault();
					c.expanded.add(key);
					this.applyCompactState();
					this.focusFirstIn(lineEl, '[data-line-full]');
					break;
				case 'edit':
					e.preventDefault();
					c.openEditor(lineEl);
					break;
				case 'hint-pack':
					e.preventDefault();
					c.openEditor(lineEl, {
						purchase: 'sub',
						variantId: toInt(btn.dataset.variantId),
					});
					break;
				case 'draft-purchase':
					e.preventDefault();
					c.setDraft(key, {
						purchase: btn.dataset.value === 'sub' ? 'sub' : 'onetime',
					});
					break;
				case 'draft-pack': {
					e.preventDefault();
					if (btn.disabled) return;
					const variantId = toInt(btn.dataset.variantId);
					const planId = lineEl ? LineModel.defaultPlanId(lineEl, variantId) : null;
					c.setDraft(key, {
						variantId,
						planId: planId || null,
					});
					break;
				}
				case 'draft-cadence':
					e.preventDefault();
					c.setDraft(key, {
						planId: toInt(btn.dataset.planId),
					});
					break;
				case 'toggle-cadence': {
					e.preventDefault();
					const d = c.drafts.get(key);
					if (d)
						c.setDraft(key, {
							cadenceOpen: !d.cadenceOpen,
						});
					break;
				}
				case 'use-recommended': {
					e.preventDefault();
					const warn = btn.closest('[data-cadence-mismatch]');
					const rec = warn && warn.dataset.recPlan;
					if (rec)
						c.setDraft(key, {
							planId: toInt(rec),
						});
					break;
				}
				case 'nudge': {
					e.preventDefault();
					track('nudge_clicked', {
						key,
					});
					c.setDraft(key, {
						purchase: 'sub',
						planId: toInt(btn.dataset.planId) || null,
					});
					break;
				}
				case 'save':
					e.preventDefault();
					c.saveDraft(key);
					break;
				case 'cancel':
					e.preventDefault();
					c.closeEditor(key);
					break;
				case 'save-all':
					e.preventDefault();
					c.saveAll();
					break;
				case 'cancel-all':
					e.preventDefault();
					c.cancelAll();
					break;
				case 'invite-accept':
					e.preventDefault();
					c.acceptInvite(btn);
					break;
				case 'invite-dismiss':
					e.preventDefault();
					c.dismissInvite(!0, this);
					break;
				case 'pack-toggle':
					e.preventDefault();
					c.packOpen = !c.packOpen;
					if (c.packOpen) track('pack_pack_details_opened', {});
					this.applyInviteState();
					break;
				case 'gift-open':
					e.preventDefault();
					this.openGiftSheet(btn);
					break;
				case 'gift-close':
					e.preventDefault();
					this.closeGiftSheet();
					break;
				case 'gift-pick':
					e.preventDefault();
					if (btn.disabled) return;
					c.giftDraft = {
						variantId: toInt(btn.dataset.variantId),
						name: btn.dataset.name,
						discountName: btn.dataset.giftTierKey || '',
					};
					this.renderGiftSheetState();
					break;
				case 'gift-confirm':
					e.preventDefault();
					c.confirmGift(this);
					break;
				case 'protection-info':
					e.preventDefault();
					this.openProtectionInfo(btn);
					break;
				case 'protection-details':
					e.preventDefault();
					c.protDetails = !c.protDetails;
					this.renderProtectionDetails();
					break;
				case 'retry':
					e.preventDefault();
					c.retry();
					break;
				case 'reload':
					e.preventDefault();
					window.location.reload();
					break;
				case 'error-dismiss':
					e.preventDefault();
					c.hideError();
					break;
				case 'undo':
					e.preventDefault();
					c.doUndo();
					break;
				case 'undo-dismiss':
					e.preventDefault();
					c.setUndo(null);
					break;
				case 'checkout':
					e.preventDefault();
					c.checkout(this, btn);
					break;
				default:
					this.onExtraAction(action, btn, e);
			}
		}
		onExtraAction() {}
		onKeydown(e) {
			if (!this.ownsNode(e.target)) return;
			if (e.key === 'Escape') {
				if (this.controller.giftOpen) {
					e.stopPropagation();
					e.preventDefault();
					this.closeGiftSheet();
					return;
				}
				if (this.close) {
					e.preventDefault();
					this.close();
				}
				return;
			}
			if (e.key === 'Tab') {
				const scope = this.controller.giftOpen ? qs('[data-gift-sheet]', this.root) : this.trapScope ? this.trapScope() : null;
				if (!scope) return;
				const f = focusables(scope);
				if (!f.length) return;
				const first = f[0],
					last = f[f.length - 1];
				if (e.shiftKey && (document.activeElement === first || !scope.contains(document.activeElement))) {
					e.preventDefault();
					last.focus();
				} else if (!e.shiftKey && (document.activeElement === last || !scope.contains(document.activeElement))) {
					e.preventDefault();
					first.focus();
				}
			}
		}
	}
	class DrawerView extends CartView {
		constructor(hostEl) {
			super(hostEl, 'drawer');
			this.themeShell = hostEl.closest('#t4s-mini_cart, [data-cart-wrapper].t4s-drawer');
			this.embedded = hostEl.hasAttribute('data-nubest-cart-embedded') || (!!this.themeShell && this.themeShell !== hostEl);
			this.panel = this.embedded ? hostEl : qs('[data-drawer-panel]', hostEl) || this.root || hostEl;
			this.isOpen = this.embedded ? !!(this.themeShell && this.themeShell.getAttribute('aria-hidden') !== 'true') : !1;
			this.lastFocus = null;
			this.openedAt = 0;
			this.freshAt = Date.now();
		}
		trapScope() {
			return this.embedded ? null : this.isOpen ? this.panel : null;
		}
		open(opts = {}) {
			if (!this.root) return;
			const c = this.controller;
			if (this.embedded) {
				const shell = this.themeShell;
				if (shell && window.T4SThemeSP && T4SThemeSP.Drawer && typeof T4SThemeSP.Drawer.opend === 'function' && window.jQuery) {
					T4SThemeSP.Drawer.opend(window.jQuery(shell));
				} else if (shell) {
					shell.classList.add('is--opened');
					shell.setAttribute('aria-hidden', 'false');
				}
				this.isOpen = !0;
				this.openedAt = Date.now();
				this.afterRender();
				const key = opts.addedKey || c.addedKey;
				if (key && this.line(key)) {
					setTimeout(() => this.highlight(key, !0), 30);
				}
				document.dispatchEvent(new CustomEvent('nubest:cart:open'));
				return;
			}
			if (!this.isOpen) {
				this.lastFocus = document.activeElement;
				const sbw = window.innerWidth - document.documentElement.clientWidth;
				document.documentElement.style.setProperty('--nb-scrollbar', sbw > 0 ? `${sbw}px` : '0px');
				document.documentElement.classList.add('nb-lock');
				this.host.classList.add('is-open');
				this.host.setAttribute('aria-hidden', 'false');
				this.isOpen = !0;
				this.openedAt = Date.now();
				setTimeout(() => {
					try {
						this.panel.focus({
							preventScroll: !0,
						});
					} catch (e) {
						this.panel.focus();
					}
				}, 40);
				track('cart_drawer_view', {
					lines: toInt(this.root.dataset.lines),
					hasSub: this.root.dataset.hasSub === 'true',
					due: toInt(this.root.dataset.due),
				});
				document.dispatchEvent(new CustomEvent('nubest:cart:open'));
			}
			this.afterRender();
			const key = opts.addedKey || c.addedKey;
			if (key && this.line(key)) setTimeout(() => this.highlight(key, !0), 30);
			if (!opts.fresh && Date.now() - this.freshAt > 1500) c.refresh();
		}
		close() {
			const c = this.controller;
			if (c.giftOpen) this.closeGiftSheet();
			if (this.embedded) {
				const shell = this.themeShell;
				if (shell && window.T4SThemeSP && T4SThemeSP.Drawer && typeof T4SThemeSP.Drawer.close === 'function' && window.jQuery) {
					T4SThemeSP.Drawer.close();
				}
				this.isOpen = !1;
				c.addedKey = null;
				document.dispatchEvent(new CustomEvent('nubest:cart:close'));
				return;
			}
			if (!this.isOpen) return;
			this.host.classList.remove('is-open');
			this.host.setAttribute('aria-hidden', 'true');
			document.documentElement.classList.remove('nb-lock');
			this.isOpen = !1;
			if (c.undo && c.undo.sticky) c.setUndo(null);
			c.addedKey = null;
			const lf = this.lastFocus;
			this.lastFocus = null;
			if (lf && lf.isConnected && lf.focus) {
				try {
					lf.focus({
						preventScroll: !0,
					});
				} catch (e) {}
			}
			document.dispatchEvent(new CustomEvent('nubest:cart:close'));
		}
		applyHtml(html, ctx) {
			super.applyHtml(html, ctx);
			this.freshAt = Date.now();
		}
	}
	class PageView extends CartView {
		constructor(hostEl) {
			super(hostEl, 'page');
			this.ui = {
				note: !1,
				promo: !1,
				renewals: !1,
				rewards: !1,
			};
			this.noteTimer = 0;
			this.mq = window.matchMedia ? window.matchMedia('(max-width: 640px)') : null;
			if (this.mq && this.mq.addEventListener) this.mq.addEventListener('change', () => this.afterRenderExtra());
			this.bindPage();
			track('cart_page_view', {
				lines: toInt(this.root.dataset.lines),
				hasSub: this.root.dataset.hasSub === 'true',
				due: toInt(this.root.dataset.due),
			});
			this.loadCodes();
		}
		trapScope() {
			return null;
		}
		bindPage() {
			this.host.addEventListener('submit', (e) => {
				const f = e.target.closest('[data-promo-form]');
				if (!f) return;
				e.preventDefault();
				this.controller.setActionButton(e.submitter || qs('[data-promo-submit]', f));
				this.applyPromo();
			});
			this.host.addEventListener('input', (e) => {
				if (e.target.matches('[data-promo-input]')) {
					const b = qs('[data-promo-submit]', this.root);
					if (b) b.disabled = !e.target.value.trim();
					const er = qs('[data-promo-error]', this.root);
					if (er) er.hidden = !0;
				}
				if (e.target.matches('[data-note]')) {
					clearTimeout(this.noteTimer);
					this.noteTimer = setTimeout(() => this.saveNote(), 900);
				}
			});
			this.host.addEventListener('focusout', (e) => {
				if (e.target.matches && e.target.matches('[data-note]')) {
					clearTimeout(this.noteTimer);
					this.saveNote();
				}
			});
		}
		onExtraAction(action, btn, e) {
			const toggle = (name, panelSel) => {
				e.preventDefault();
				this.ui[name] = !this.ui[name];
				this.renderAccordions();
				if (this.ui[name]) {
					const p = qs(panelSel, this.root);
					const f = p && focusables(p)[0];
					if (f)
						f.focus({
							preventScroll: !0,
						});
				}
			};
			switch (action) {
				case 'note-toggle':
					toggle('note', '[data-note-panel]');
					break;
				case 'promo-toggle':
					toggle('promo', '[data-promo-panel]');
					break;
				case 'renewals-toggle':
					e.preventDefault();
					this.ui.renewals = !this.ui.renewals;
					if (this.ui.renewals) track('renewals_opened', {});
					this.renderAccordions();
					break;
				case 'rewards-toggle':
					e.preventDefault();
					this.ui.rewards = !this.ui.rewards;
					this.renderAccordions();
					break;
				case 'promo-remove':
					e.preventDefault();
					this.removePromo();
					break;
				default:
					break;
			}
		}
		afterRenderExtra() {
			this.renderAccordions();
			this.renderPromo();
			this.renderMobileBar();
		}
		renderMobileBar() {
			const bar = qs('[data-mobilebar]', this.root);
			if (bar) bar.hidden = this.root.classList.contains('is-empty');
		}
		renderAccordions() {
			const set = (btnSel, panelSel, open) => {
				const b = qs(btnSel, this.root);
				const p = qs(panelSel, this.root);
				if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
				if (p) p.hidden = !open;
			};
			set('[data-action="note-toggle"]', '[data-note-panel]', this.ui.note);
			set('[data-action="promo-toggle"]', '[data-promo-panel]', this.ui.promo);
			set('[data-action="renewals-toggle"]', '[data-renewals-panel]', this.ui.renewals);
			const rw = qs('[data-rewards]', this.root);
			if (rw) {
				const narrow = isNarrow();
				rw.dataset.collapsed = narrow && !this.ui.rewards ? 'true' : 'false';
				const b = qs('[data-action="rewards-toggle"]', rw);
				if (b) b.setAttribute('aria-expanded', narrow ? (this.ui.rewards ? 'true' : 'false') : 'true');
			}
		}
		async saveNote() {
			const ta = qs('[data-note]', this.root);
			if (!ta) return;
			const val = ta.value;
			if (val === (this.snapshot().note || '')) return;
			const st = qs('[data-note-status]', this.root);
			if (st) st.textContent = 'Saving…';
			try {
				await api.post('/cart/update.js', {
					note: val,
				});
				const snap = qs('[data-cart-snapshot]', this.root);
				if (snap) {
					const j = parseJSON(snap.textContent, null);
					if (j) {
						j.note = val;
						snap.textContent = JSON.stringify(j);
					}
				}
				const t = qs('[data-note-title]', this.root);
				if (t) t.textContent = val.trim() ? 'Edit your order note' : 'Add an order note';
				if (st) {
					st.textContent = 'Saved';
					setTimeout(() => {
						if (st.textContent === 'Saved') st.textContent = '';
					}, 2000);
				}
				track('note_saved', {});
			} catch (err) {
				if (st) st.textContent = "We couldn't save your note. Try again.";
			}
		}
		async loadCodes() {
			if (!qs('[data-promo-form]', this.root)) return;
			try {
				const cart = await api.getCart();
				this.controller.appliedCodes = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
				if (this.controller.appliedCodes.length) this.ui.promo = !0;
				this.renderAccordions();
				this.renderPromo();
			} catch (e) {}
		}
		renderPromo() {
			const wrap = qs('[data-promo-applied]', this.root);
			const form = qs('[data-promo-form]', this.root);
			if (!wrap || !form) return;
			const codes = this.controller.appliedCodes || [];
			const code = codes[0];
			wrap.hidden = !code;
			form.hidden = !!code;
			if (code) {
				const disc = toInt(this.root.dataset.productDisc) + toInt(this.root.dataset.orderDisc);
				const t = qs('[data-promo-applied-text]', wrap);
				if (t) t.textContent = code.applicable && disc > 0 ? `${code.code} applied · −${this.money(disc)}` : `${code.code} · not applied to this cart`;
				wrap.classList.toggle('nb-promo__applied--inactive', !code.applicable);
			}
		}
		async applyPromo() {
			const input = qs('[data-promo-input]', this.root);
			if (!input) return;
			const code = input.value.trim().toUpperCase();
			if (!code) return;
			const c = this.controller;
			if (c.busy) return;
			if (this.config.promoMode === 'redirect') {
				window.location.href = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(window.location.pathname + window.location.search)}`;
				return;
			}
			const err = qs('[data-promo-error]', this.root);
			const res = await c.run(
				`${code} applied`,
				[
					{
						type: 'update',
						body: {
							discount: code,
						},
					},
				],
				{
					undoable: !1,
					errorText: "We couldn't apply that code right now. Your cart is unchanged.",
				},
			);
			if (!res) return;
			const codes = Array.isArray(res.discount_codes) ? res.discount_codes : null;
			if (!codes) {
				window.location.href = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(window.location.pathname + window.location.search)}`;
				return;
			}
			const hit = codes.find((x) => String(x.code).toUpperCase() === code);
			if (hit && hit.applicable) {
				c.appliedCodes = codes;
				input.value = '';
				if (err) err.hidden = !0;
				this.renderPromo();
				track('promo_applied', {
					code,
				});
			} else {
				c.appliedCodes = [];
				try {
					await api.post('/cart/update.js', {
						discount: '',
					});
				} catch (e) {}
				if (err) {
					err.hidden = !1;
					err.textContent = `“${code}” isn't a valid code or doesn't apply to this cart. Check the spelling or try another code.`;
				}
				this.renderPromo();
				track('promo_invalid', {
					code,
				});
			}
		}
		async removePromo() {
			const c = this.controller;
			if (c.busy) return;
			const cur = (c.appliedCodes || [])[0];
			const res = await c.run(
				'Code removed',
				[
					{
						type: 'update',
						body: {
							discount: '',
						},
					},
				],
				{
					undoable: !1,
				},
			);
			if (res) {
				c.appliedCodes = [];
				this.renderPromo();
				track('promo_removed', {
					code: cur ? cur.code : '',
				});
			}
		}
	}
	const controller = new CartController();
	async function ensureMounted() {
		mount();
		if (!controller.views.length) {
			await new Promise((resolve) => raf(resolve));
			mount();
		}
		return controller;
	}
	async function publicAdd(items, opts = {}) {
		await ensureMounted();
		const list = (Array.isArray(items) ? items : [items]).filter(Boolean);
		if (!list.length) return !1;
		const first = list[0];
		const result = await controller.run(
			opts.label || 'Item added',
			[
				{
					type: 'add',
					items: list,
				},
			],
			{
				addedTarget: first
					? {
							id: toInt(first.id),
							selling_plan: first.selling_plan || null,
						}
					: null,
				errorText: opts.errorText,
			},
		);
		if (!result) return !1;
		document.dispatchEvent(
			new CustomEvent('nubest:cart:added', {
				detail: {
					items: result.items || list,
					cart: result,
				},
			}),
		);
		const drawer = controller.drawer();
		if (opts.open !== !1 && drawer)
			drawer.open({
				addedKey: controller.addedKey,
				fresh: !0,
			});
		if (typeof opts.done === 'function') opts.done(result);
		return result;
	}
	async function publicAddForm(formOrData, opts = {}) {
		await ensureMounted();
		let form = null;
		let formData;
		if (formOrData instanceof FormData) {
			formData = formOrData;
		} else if (typeof HTMLFormElement !== 'undefined' && formOrData instanceof HTMLFormElement) {
			form = formOrData;
			if (!form.noValidate && !(opts.submitter && opts.submitter.formNoValidate) && !form.reportValidity()) return !1;
			formData = new FormData(form);
			if (opts.submitter && opts.submitter.name && opts.submitter.name !== 'add') formData.append(opts.submitter.name, opts.submitter.value);
		} else {
			throw new TypeError('NuBestCart.addForm() expects an HTMLFormElement or FormData');
		}
		controller.cartStart({
			source: 'add-form',
			label: opts.label || 'Item added',
		});
		const res = await api.addForm(formData, controller.sectionIds());
		const items = res.items || [res];
		const added = items[0];
		controller.addedKey = added ? added.key : null;
		controller.autoFixDone.clear();
		controller.applySections(res.sections || {}, {
			cart: res,
		});
		controller.setUndo(null);
		document.dispatchEvent(
			new CustomEvent('nubest:cart:added', {
				detail: {
					items,
					cart: res,
				},
			}),
		);
		if (form)
			form.dispatchEvent(
				new CustomEvent('nubest:cart:added', {
					bubbles: !0,
					detail: {
						items,
					},
				}),
			);
		const drawer = controller.drawer();
		if (opts.open !== !1 && drawer)
			drawer.open({
				addedKey: controller.addedKey,
				fresh: !0,
			});
		await controller.autoFix();
		controller.cartDone({
			source: 'add-form',
			label: opts.label || 'Item added',
			cart: res,
		});
		if (typeof opts.done === 'function') opts.done(res);
		return res;
	}
	async function publicChange(id, options = {}) {
		await ensureMounted();
		if (id == null || id === '') throw new TypeError('NuBestCart.change() requires a line key/id');
		const step = {
			type: 'change',
			id,
		};
		if (options.quantity !== undefined) step.quantity = toInt(options.quantity);
		if (options.selling_plan !== undefined) step.selling_plan = options.selling_plan;
		if (options.properties !== undefined) step.properties = options.properties;
		const result = await controller.run(options.label || 'Cart updated', [step], options.runOptions || {});
		if (result && typeof options.done === 'function') options.done(result);
		return result;
	}
	async function publicUpdate(body, opts = {}) {
		await ensureMounted();
		if (!body || typeof body !== 'object') throw new TypeError('NuBestCart.update() requires a cart update body');
		const result = await controller.run(
			opts.label || 'Cart updated',
			[
				{
					type: 'update',
					body,
				},
			],
			opts.runOptions || {},
		);
		if (result && typeof opts.done === 'function') opts.done(result);
		return result;
	}
	async function publicSwap(from, to, opts = {}) {
		await ensureMounted();

		if (from == null || from === '') {
			throw new TypeError('NuBestCart.swap() requires a source line key/id');
		}

		if (!to || typeof to !== 'object' || !to.id) {
			throw new TypeError('NuBestCart.swap() requires a target item with id');
		}

		let source = null;

		let items = (controller.snapshot() && controller.snapshot().items) || [];

		const matchSource = (item) => item && (String(item.key) === String(from) || String(item.id || item.variant_id) === String(from));

		source = items.find(matchSource) || null;

		if (!source) {
			const cart = await api.getCart();

			items = (cart && cart.items) || [];
			source = items.find(matchSource) || null;
		}

		if (!source) {
			throw new Error('NuBestCart.swap() could not find the source cart item');
		}

		const sourceKey = source.key || from;
		const sourceVariantId = toInt(source.id || source.variant_id);
		const targetVariantId = toInt(to.id);

		const quantity = to.quantity !== undefined ? toInt(to.quantity) : toInt(source.quantity, 1);

		const sameVariant = sourceVariantId === targetVariantId;

		let steps;

		if (sameVariant) {
			const step = {
				type: 'change',
				id: sourceKey,
				quantity,
			};

			if (to.selling_plan !== undefined) {
				step.selling_plan = to.selling_plan;
			}

			if (to.properties !== undefined) {
				step.properties = to.properties;
			}

			steps = [step];
		} else {
			const nextItem = {
				id: targetVariantId,
				quantity,
			};

			if (to.selling_plan !== undefined && to.selling_plan !== null && to.selling_plan !== '') {
				nextItem.selling_plan = to.selling_plan;
			}

			const properties = to.properties !== undefined ? normalizeProperties(to.properties) : normalizeProperties(source.properties);

			if (properties) {
				nextItem.properties = properties;
			}

			steps = [
				{
					type: 'add',
					items: [nextItem],
				},
				{
					type: 'change',
					id: sourceKey,
					quantity: 0,
				},
			];
		}

		const runOptions = Object.assign(
			{
				undoable: opts.undoable !== !1,
				flashTarget: {
					id: targetVariantId,
					selling_plan: to.selling_plan || null,
				},
			},
			opts.runOptions || {},
		);

		const result = await controller.run(opts.label || 'Item swapped', steps, runOptions);

		if (result && typeof opts.done === 'function') {
			opts.done(result);
		}

		return result;
	}
	async function publicRemove(id, opts = {}) {
		return publicChange(id, {
			quantity: 0,
			label: opts.label || 'Item removed',
			runOptions: Object.assign(
				{
					undoable: opts.undoable !== !1,
				},
				opts.runOptions || {},
			),
			done: opts.done,
		});
	}
	async function publicClearCart(opts = {}) {
		await ensureMounted();
		const res = await api.post('/cart/clear.js', {}, controller.sectionIds());
		let renderedSections = res && res.sections ? res.sections : {};
		const expectedSections = controller.sectionIds();
		if (expectedSections.some((id) => typeof renderedSections[id] !== 'string')) {
			try {
				renderedSections = await api.getSections(expectedSections);
			} catch (e) {}
		}
		controller.applySections(renderedSections, { cart: res });
		await controller.autoFix();
		if (res && typeof opts.done === 'function') opts.done(res);
		return res;
	}
	async function publicSection(sectionIds, opts = {}) {
		await ensureMounted();

		const single = !Array.isArray(sectionIds);
		const ids = [...new Set((single ? [sectionIds] : sectionIds).map((id) => String(id || '').trim()).filter(Boolean))];

		if (!ids.length) throw new TypeError('NuBestCart.section() requires a section id or array of section ids');

		const sections = await api.getSections(ids, opts.url || null);
		const result = single ? sections[ids[0]] : sections;

		if (opts.applyTo && single) {
			const targets = typeof opts.applyTo === 'string' ? document.querySelectorAll(opts.applyTo) : opts.applyTo instanceof Element ? [opts.applyTo] : opts.applyTo;
			[...targets].filter(Boolean).forEach((el) => (el.innerHTML = result || ''));
		}

		if (typeof opts.done === 'function') opts.done(result);
		return result;
	}
	window.addEventListener('pageshow', (event) => {
		const returnedFromCheckout = controller.checkoutPending;
		if (returnedFromCheckout) {
			controller.checkoutPending = !1;
			controller.setActionButton(null);
			controller.views.forEach((view) => view.renderDirty());
		}
		if (!event.persisted && !returnedFromCheckout) return;
		mount();
		if (!controller.views.some((view) => view.context === 'page')) return;
		controller.refresh({
			force: !0,
		});
	});
	let atcTakeoverBound = !1;

	function setupAtcTakeover(drawer) {
		if (drawer.embedded || !drawer.config.takeoverAtc || atcTakeoverBound) return;
		atcTakeoverBound = !0;
		const activeDrawer = () => {
			const current = controller.drawer();
			return current && !current.embedded && current.config.takeoverAtc ? current : null;
		};
		const isAtcForm = (form) => {
			if (!form || form.tagName !== 'FORM') return !1;
			if (form.hasAttribute('data-nubest-cart-ignore') || form.closest(DRAWER_SEL)) return !1;
			const action = form.getAttribute('action') || '';
			return /\/cart\/add(\.js)?(\?|$)/.test(action);
		};
		const handleAdd = async (form, submitter) => {
			const currentDrawer = activeDrawer();
			if (!currentDrawer || form.__nbAdding) return;
			if (!form.noValidate && !(submitter && submitter.formNoValidate) && !form.reportValidity()) return;
			form.__nbAdding = !0;
			const btns = [submitter, ...qsa('[type="submit"],[name="add"]', form)].filter(Boolean);
			btns.forEach((b) => {
				b.classList.add('nb-atc-busy');
				b.setAttribute('aria-busy', 'true');
			});
			try {
				await publicAddForm(form, {
					submitter,
					open: currentDrawer.config.openOnAdd !== !1,
				});
			} catch (err) {
				showGlobalError(err.message || "We couldn't add this to your cart.");
			} finally {
				form.__nbAdding = !1;
				btns.forEach((b) => {
					b.classList.remove('nb-atc-busy');
					b.removeAttribute('aria-busy');
				});
			}
		};
		document.addEventListener(
			'submit',
			(e) => {
				if (!activeDrawer()) return;
				const form = e.target;
				if (!isAtcForm(form)) return;
				e.preventDefault();
				e.stopPropagation();
				e.stopImmediatePropagation();
				handleAdd(form, e.submitter || null);
			},
			!0,
		);
		document.addEventListener(
			'click',
			(e) => {
				if (!activeDrawer()) return;
				const btn = e.target.closest && e.target.closest('button,input[type="submit"]');
				if (!btn) return;
				const form = btn.form || btn.closest('form');
				if (!isAtcForm(form)) return;
				const type = (btn.getAttribute('type') || 'submit').toLowerCase();
				if (type !== 'submit' || btn.disabled) return;
				if (btn.name === 'checkout' || btn.matches('[data-buy-now], [data-nubest-cart-ignore], .shopify-payment-button__button, .t4s-btn-buynow')) return;
				e.preventDefault();
				e.stopPropagation();
				e.stopImmediatePropagation();
				handleAdd(form, btn);
			},
			!0,
		);
	}
	let openTriggersBound = !1;

	function setupOpenTriggers(drawer) {
		if (drawer.embedded || openTriggersBound) return;
		openTriggersBound = !0;
		document.addEventListener(
			'click',
			(e) => {
				const current = controller.drawer();
				if (!current || current.embedded) return;
				const sels = (current.config.openSelectors || '').trim();
				if (!sels) return;
				const t = e.target.closest ? e.target.closest(sels) : null;
				if (!t || t.closest(DRAWER_SEL)) return;
				if (t.tagName === 'A') {
					const href = t.getAttribute('href') || '';
					if (/\/cart\/(add|change|update|clear)/.test(href) || /checkout/.test(href)) return;
				}
				e.preventDefault();
				e.stopPropagation();
				e.stopImmediatePropagation();
				current.open();
			},
			!0,
		);
	}
	function setupExternalCartWatch() {
		const ours = (headers) => {
			if (!headers) return !1;
			if (headers instanceof Headers) return headers.has(OUR_HEADER);
			if (Array.isArray(headers)) return headers.some((h) => h[0] && h[0].toLowerCase() === OUR_HEADER.toLowerCase());
			return Object.keys(headers).some((k) => k.toLowerCase() === OUR_HEADER.toLowerCase());
		};

		const isCartUrl = (url) => /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url || ''));

		const sync = async (data, isAdd) => {
			mount();

			const ids = controller.sectionIds();
			const sections = data && data.sections;
			const hasSections = sections && controller.sectionIds().some((id) => typeof sections[id] === 'string');

			controller.cartStart({ source: isAdd ? 'external-add' : 'external-mutation', label: isAdd ? 'Item added externally' : 'External cart update' });

			if (hasSections) {
				controller.applySections(sections, { cart: data });
				await controller.autoFix();
			} else {
				await controller.refresh({ source: isAdd ? 'external-add' : 'external-mutation', label: isAdd ? 'Item added externally' : 'External cart update' });
				return;
			}

			controller.cartDone({ source: isAdd ? 'external-add' : 'external-mutation', label: isAdd ? 'Item added externally' : 'External cart update', cart: data });

			const d = controller.drawer();
			if (isAdd && d && d.config.openOnAdd !== !1) d.open({ fresh: !0 });
		};

		if (window.fetch) {
			const of = window.fetch;

			window.fetch = function (input, init) {
				const url = typeof input === 'string' ? input : input && input.url;
				const headers = (init && init.headers) || (input && input.headers);
				const p = of.apply(this, arguments);

				if (isCartUrl(url) && !ours(headers)) {
					p.then(async (r) => {
						if (!r || !r.ok) return;
						const data = await r
							.clone()
							.json()
							.catch(() => null);
						sync(data, /\/cart\/add/.test(url));
					}).catch(() => {});
				}

				return p;
			};
		}

		if (window.XMLHttpRequest) {
			const oo = XMLHttpRequest.prototype.open;

			XMLHttpRequest.prototype.open = function (method, url) {
				if (isCartUrl(url)) {
					this.addEventListener('load', () => {
						if (this.status < 200 || this.status >= 300) return;
						const data = this.responseType === 'json' ? this.response : parseJSON(this.responseText, null);
						sync(data, /\/cart\/add/.test(url));
					});
				}

				return oo.apply(this, arguments);
			};
		}

		document.addEventListener('nubest:cart:refresh', () => controller.refresh());
	}
	let globalErrorEl = null;

	function showGlobalError(text) {
		if (globalErrorEl) globalErrorEl.remove();
		const el = document.createElement('div');
		el.className = 'nb-global-error';
		el.setAttribute('role', 'alert');
		el.innerHTML = `<span></span><button type="button">Dismiss</button>`;
		el.firstChild.textContent = text;
		el.lastChild.addEventListener('click', () => el.remove());
		document.body.appendChild(el);
		globalErrorEl = el;
		setTimeout(() => {
			if (el.isConnected) el.remove();
		}, 8000);
	}
	const giftCardsMounted = new WeakSet();
	function setupNuBestGiftCards() {
		qsa('nubest-gift-card').forEach((root) => {
			if (giftCardsMounted.has(root)) return;
			const form = qs('[data-gc-form]', root);
			if (!form) return;
			const button = qs('[data-gc-submit]', form);
			if (!button) return;
			giftCardsMounted.add(root);
			const recipient = qs('[data-gc-recipient]', root);
			const delivery = qs('[data-gc-delivery]', root);
			const date = qs('[data-gc-date]', root);
			const dateWrap = qs('[data-gc-date-wrap]', root);
			const email = qs('[data-gc-email]', root);
			const message = qs('[data-gc-message]', root);
			const offset = qs('[data-gc-offset]', root);
			const selfHelp = qs('[data-gc-self-help]', root);
			const giftHelp = qs('[data-gc-gift-help]', root);
			const count = qs('[data-gc-count]', root);
			const variantLabel = () => {
				const selected = qs('[name="id"]:checked', form);
				return selected ? selected.dataset.money || '' : '';
			};
			const updateButton = () => {
				const choice = qs('[name="id"]:checked', form);
				const available = !!choice && !choice.disabled;
				const giftInput = qs('[data-gc-mode="gift"]', root);
				const laterInput = qs('[data-gc-timing="later"]', root);
				const gift = !!giftInput && giftInput.checked;
				const scheduled = gift && !!laterInput && laterInput.checked;
				const emailValid = !gift || !email || email.checkValidity();
				const dateValid = !scheduled || !date || date.checkValidity();
				const valid = available && emailValid && dateValid;
				button.disabled = !valid;
				const text = qs('[data-gc-button-text]', button);
				if (text) {
					text.textContent = `${variantLabel()}`;
				}
			};
			const ymd = (value) => {
				return [value.getFullYear(), String(value.getMonth() + 1).padStart(2, '0'), String(value.getDate()).padStart(2, '0')].join('-');
			};
			const updateDates = () => {
				if (!date) return;
				const today = new Date();
				const limit = new Date(today);
				limit.setDate(limit.getDate() + 90);
				date.min = ymd(today);
				date.max = ymd(limit);
				if (offset) {
					offset.value = String(today.getTimezoneOffset());
				}
			};
			const updateDelivery = () => {
				if (!recipient) return;
				const giftInput = qs('[data-gc-mode="gift"]', root);
				const laterInput = qs('[data-gc-timing="later"]', root);
				const gift = !!giftInput && giftInput.checked;
				const scheduled = gift && !!laterInput && laterInput.checked;
				recipient.hidden = !gift;
				recipient.disabled = !gift;
				if (email) {
					email.required = gift;
				}
				if (dateWrap) {
					dateWrap.hidden = !scheduled;
				}
				if (date) {
					date.disabled = !scheduled;
					date.required = scheduled;
					if (!scheduled) {
						date.value = '';
						date.setCustomValidity('');
					}
				}
				if (selfHelp) {
					selfHelp.hidden = gift;
				}
				if (giftHelp) {
					giftHelp.hidden = !gift;
				}
				updateDates();
				updateButton();
			};
			if (delivery) {
				delivery.hidden = !1;
				delivery.addEventListener('change', updateDelivery);
			}
			if (recipient) {
				recipient.addEventListener('change', (event) => {
					if (event.target.matches('[data-gc-timing]')) {
						updateDelivery();
					}
				});
			}
			if (email) {
				email.addEventListener('input', updateButton);
				email.addEventListener('change', updateButton);
			}
			if (date) {
				date.addEventListener('input', updateButton);
				date.addEventListener('change', updateButton);
			}
			if (message && count) {
				message.addEventListener('input', () => {
					count.textContent = String(message.value.length);
				});
			}
			qsa('[name="id"]', form).forEach((input) => {
				input.addEventListener('change', updateButton);
			});
			updateDates();
			updateDelivery();
			updateButton();
		});
	}
	const mounted = new WeakSet();

	function mount() {
		controller.views = controller.views.filter((v) => v.host.isConnected);
		qsa(DRAWER_SEL).forEach((host) => {
			if (mounted.has(host)) return;
			const view = new DrawerView(host);
			if (!view.root) return;
			mounted.add(host);
			debug = debug || !!view.config.debug;
			controller.register(view);
			view.afterRender();
			setupAtcTakeover(view);
			setupOpenTriggers(view);
			controller.updateHeaderCount();
			controller.autoFix();
		});
		qsa(PAGE_SEL).forEach((host) => {
			if (mounted.has(host)) return;
			const view = new PageView(host);
			if (!view.root) return;
			mounted.add(host);
			debug = debug || !!view.config.debug;
			controller.register(view);
			view.afterRender();
			controller.autoFix();
		});
		setupNuBestGiftCards();
	}
	document.addEventListener('keydown', (e) => {
		if (e.key !== 'Escape') return;
		const d = controller.drawer();
		if (d && d.isOpen && !d.host.contains(document.activeElement)) {
			if (controller.giftOpen) d.closeGiftSheet();
			else d.close();
		}
	});
	document.addEventListener('shopify:section:load', () => {
		mount();
	});
	document.addEventListener('shopify:section:select', (e) => {
		const d = controller.drawer();
		if (d && e.detail && e.detail.sectionId === d.sectionId)
			d.open({
				fresh: !0,
			});
	});
	document.addEventListener('shopify:section:deselect', (e) => {
		const d = controller.drawer();
		if (d && e.detail && e.detail.sectionId === d.sectionId) d.close();
	});
	// Clear previous promo codes and their accessible cookie once per tab session.
	// Does not change automatic discounts or subscription selling-plan prices.
	const DISCOUNT_CLEANUP_KEY = 'nbcart_discount_cleanup_v2';
	function clearDiscountCodeCookie() {
		const hostname = window.location.hostname;
		const domains = ['']; // Host-only cookie
		// Also clear a cookie created for the shared NuBest parent domain.
		if (hostname === 'nubest.com' || hostname.endsWith('.nubest.com')) domains.push('nubest.com');
		if (hostname) domains.push(hostname);
		const paths = ['/'];
		const segments = window.location.pathname.split('/').filter(Boolean);
		let prefix = '';
		for (const segment of segments) {
			prefix += '/' + segment;
			paths.push(prefix, prefix + '/');
		}
		for (const domain of new Set(domains)) {
			for (const path of new Set(paths)) {
				const domainAttr = domain ? `; Domain=${domain}` : '';
				document.cookie = `discount_code=; Max-Age=0; Path=${path}${domainAttr}; SameSite=Lax`;
			}
		}
	}
	async function cleanupPreviousDiscounts() {
		try {
			if (sessionStorage.getItem(DISCOUNT_CLEANUP_KEY) === '1') return;
			clearDiscountCodeCookie();
			const cart = await api.getCart();
			const codes = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
			if (codes.length) {
				const updated = await api.post('/cart/update.js', { discount: '' });
				controller.appliedCodes = Array.isArray(updated.discount_codes) ? updated.discount_codes : [];
				await controller.refresh({ force: !0, source: 'discount-cleanup', label: 'Previous discount removed' });
			} else {
				controller.appliedCodes = [];
			}
			clearDiscountCodeCookie();
			sessionStorage.setItem(DISCOUNT_CLEANUP_KEY, '1');
		} catch (err) {
			log('discount cleanup failed', err);
		}
	}
	setupExternalCartWatch();
	function logEvent() {
		(($) => {
			const originalDispatchEvent = EventTarget.prototype.dispatchEvent;
			EventTarget.prototype.dispatchEvent = function (event) {
				if (['triggering-state-update', 'pre-triggering-state-update', 'onsite-event-publish', 'T4sHeaderHide', 'T4sHeaderReveal', 'lazyloaded', 'lazybeforeunveil', 'lazyunveilread', 'lazybeforesizes', 'lazyriasmodifyoptions', '_lazyloaded'].indexOf(event.type) === -1) {
					log('✅ [DOM EVENT]', event.type, {
						type: event.type,
						detail: event.detail,
						target: this,
						event,
					});
				}
				return originalDispatchEvent.call(this, event);
			};
			if (!$ || !$.fn || !$.fn.trigger) return;
			const originalTrigger = $.fn.trigger;
			$.fn.trigger = function (type, data) {
				const eventType = typeof type === 'string' ? type : type && type.type;
				if (['scroll.flickityt4s', 'select.flickityt4s', 'cellSelect.flickityt4s', 'ready.flickityt4s', 'settle.flickityt4s', 'select.carousel', 'change.flickityt4s', 'click', 'click.sticky'].indexOf(eventType) === -1) {
					log('✅ [jQuery.trigger]', eventType, {
						target: this,
						data,
					});
				}
				return originalTrigger.apply(this, arguments);
			};
		})(window.jQuery);
	}
	if (debug) {
		logEvent();
	}
	let mountQueued = !1;
	const queueMount = () => {
		if (mountQueued) return;
		mountQueued = !0;
		raf(() => {
			mountQueued = !1;
			mount();
		});
	};
	const startMountObserver = () => {
		if (!window.MutationObserver || !document.documentElement) return;
		const mo = new MutationObserver((mutations) => {
			for (const mutation of mutations) {
				for (const node of mutation.addedNodes || []) {
					if (!node || node.nodeType !== 1) continue;
					if ((node.matches && (node.matches(DRAWER_SEL) || node.matches(PAGE_SEL))) || (node.querySelector && (node.querySelector(DRAWER_SEL) || node.querySelector(PAGE_SEL)))) {
						queueMount();
						return;
					}
				}
			}
		});
		mo.observe(document.documentElement, {
			childList: !0,
			subtree: !0,
		});
	};
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', () => {
			mount();
			startMountObserver();
			controller.autoAddBundles();
		});
	} else {
		mount();
		startMountObserver();
		controller.autoAddBundles();
	}
	const cart = {
		section: publicSection,
		add: publicAdd,
		addForm: publicAddForm,
		change: publicChange,
		swap: publicSwap,
		update: publicUpdate,
		remove: publicRemove,
		clear: publicClearCart,
		cart: () => api.getCart(),
		refresh: (opts = {}) => {
			mount();
			return controller.refresh(opts);
		},
		open: (opts = {}) => {
			mount();
			const drawer = controller.drawer();
			if (!drawer) return !1;
			drawer.open(opts);
			return !0;
		},
		close: () => {
			const drawer = controller.drawer();
			if (!drawer) return !1;
			drawer.close();
			return !0;
		},
		version: '1.3.1',
	};
	window.NuBestCart = cart;
	document.dispatchEvent(
		new CustomEvent('nubest:cart:ready', {
			detail: { cart },
		}),
	);
})();
